import loanactive from "../../../assets/images/loanactive.png";
import USER from "../../../assets/images/user1.jpg";
import initiateddot from "../../../assets/images/initiatedDot.png";
import pendingdot from "../../../assets/images/pendingDot.png";
import activedot from "../../../assets/images/activeDot.png";
import closeddot from "../../../assets/images/closedDot.png";
import PaymentLink from "./PaymentLink";
import 'moment-timezone';
import moment from 'moment';
import Datetime from 'react-datetime';
import close from "../../../assets/images/close.png";
import AddReminder from "./AddReminder";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ManualPayment from './ManualPayment';
import { useSelector, useDispatch } from "react-redux";
import { ModalHeader, ModalBody, Button, Label, InputGroup, Input, ModalFooter } from 'reactstrap';
import { Box, TextField, Divider, Grid, Tooltip } from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import LoanActivity from '../../LoanActivity/Loanactivity';
import AddCall from "./AddCall";
import copy from "../../../assets/images/copy.png";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import MuiButton from '@mui/material/Button';
import { LoanStatus } from '../../../utils/constants/status.ts';
import {statusStyles} from '../../../utils/constants/statusStyles.ts';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import WifiCalling3OutlinedIcon from '@mui/icons-material/WifiCalling3Outlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Form, FormGroup,
  Modal,
} from 'reactstrap';
import { userActions } from "../../../actions/user.actions";
import axiosInstance from '../../../helpers/axios';
import DetailsCard from './DetailsCard.jsx';
import Connect from './Connect.jsx';
import Amounts from './Amounts.jsx';
import { CheckIcon } from 'lucide-react';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { appContextConstants } from '../../../constants/appContext.constants';
import { useLocation } from 'react-router-dom';
const yesterday = moment().endOf("day");
const loanStatusOptions = {
  1: 'Active',
  2: 'Closed',
  8: 'Legal',
  12: 'Settled-Closed'
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

function LoanProfile(){

  const decode = useCurrentUser();
  const user = null;
    const loanstate = useSelector((state) => state.LoanDetails?.res);
const callstate = useSelector((state) => state.Calldetails?.res);
    const emiHistoryState = useSelector((state) => state?.getEmiHistory?.res?.data?.data);
    const getReminderState=useSelector((state)=>state?.getReminder?.res?.data?.data)
    const { loanid: reduxLoanId, legacyLoanId: reduxLegacyLoanId, repaymentsUserId } = useSelector(state => state.appContext);
    // Fall back to URL params when opened in a new window (Redux not shared across windows)
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const LoanId = reduxLoanId || urlParams.get('loanId');
    const legacyLoanId = reduxLegacyLoanId || decodeURIComponent(urlParams.get('legacyLoanId') || '');
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loanDetails, setLoanDetails] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [tokenId, setTokenId] = useState('');
    const [umrn, setUmrn] = useState('');
    const [mandateType, setMandateType] = useState('');
    const [submitAttempted, setSubmitAttempted] = useState(false);
    const [emiHistoryData, setEmiHistory] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedEmiStatuses, setSelectedEmiStatuses] = useState([]);
    const [totalEmiAmount, setTotalEmiAmount] = useState(0);
    const [principleAmount, setPrincipleAmount] = useState(0);
    const [legalCharges, setLegalCharges] = useState(0);
    const [interest, setInterest] = useState(0);
    const [principle, setPrinciple] = useState(0);
    const [remainingAmountToBePaid, setRemainingAmountToBePaid] = useState(0);
    const [paidPrinciple, setPaidPrinciple] = useState(0);
    const [paidInterest, setPaidInterest] = useState(0);
    const [overdueCharges, setOverdueCharges] = useState(0);
    const [chequeBounceCharges, setChequeBounceCharges] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [amount,setAmount] = useState(null)
    const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
    const [paymentLink,setPaymentLink] = useState(null)
    const [remarks,setRemarks] = useState(null)
    const [emiId,setEmiid] = useState(null)
    const [writtenoffDateError, setWrittenoffDateError] = useState(false);
    const [remarksError, setRemarksError] = useState(false);
    const [openBankStatementDialog, setOpenBankStatementDialog] = useState(false);
    const [statementLoading, setStatementLoading] = useState(false)
    const [dateRange, setDateRange] = useState([null, null]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [error, setError] = useState("");
    const [openActions, setOpenActions] = useState(false);
    const [openDocuments, setOpenDocuments] = useState(false);
    const [openCollections, setOpenCollections] = useState(false);
    const anchorRef = React.useRef(null);
    const documentRef = React.useRef(null);
    const collectRef = React.useRef(null);
    const [preCloseAmount, setPreClosureAmount] = useState(null)
    const [preClosecharges, setPreClosureCharges] = useState(null)
    const [foreCloseAmount,setForeCloseAmount] = useState(null)
    const [futureInterest,setFutureInterest] = useState(null)
    const [consentDate, setConsentDate] = useState()
    const [selectedIndex, setSelectedIndex] = React.useState(1);
    const [legalLetterModalOpen, setLegalLetterModalOpen] = useState(false);
    const [principlePaid, setPrinciplePaid] = useState(0);
    const [interestPaid, setInterestPaid] = useState(0);
    const [legalLetter, setLegalLetter] = useState({
    mandateRaisedDate: '',
    mandateFailedDate: '',
    softNoticeDate: '',
    overdueEmiAmount: '',
    penaltyAndBounceCharges: '',
    totalOutstanding: '',
    mandateFailedReason: '',
    mandateFailedCount: ''
  });
  const [refundModalOpen, setRefundModalOpen] = useState(false);
const [refundReason, setRefundReason] = useState('');
const [emails, setEmails] = useState([]); 
const [currentEmail, setCurrentEmail] = useState(''); 
const [courseName, setCourseName] = useState('');
  const [sendEmail, setSendEmail] = useState(true);
    const urlAddActivity=`/loan-repayment/activity`

const urlUsers = `/loan-repayment/profile?loanId=${LoanId}`;

const callDetailsUrl = `/call-history/details?loanId=${LoanId}`

const emihistoryUrl=`/emis/for-loan?loanId=${LoanId}`
// const urlGetReminder=`/call-history/reminder-details?userId=${userId}`

const customerDashboardLoginUrl = `/login/admin`;
 const activityState=useSelector((state)=>state?.ACTIVITY?.activityData)
const getActivityUrl=`/loan-repayment/activity?legacyLoanId=${legacyLoanId}`
const [selectedStatus, setSelectedStatus] = useState('');

 const [activityNotes,setActivityNotes]=useState('')
 const [formDataStatus,setFormDataStatus]=useState('')
//  

 const defaultStatus = 
 'from ' + 
 (loanstate?.status === 1 ? 'Active' :
   loanstate?.status === 2 ? 'Closed' :
   loanstate?.status === 3 ? 'Overdue' :
   loanstate?.status === 4 ? 'WrittenOff' :
   loanstate?.status === 5 ? 'MandateActive' :
   loanstate?.status === 6 ? 'Refund' :
   loanstate?.status === 7 ? 'Paused' :
   loanstate?.status === 8 ? 'Legal' :
   loanstate?.status === 9 ? 'Settled' :
  loanstate?.status === 11 ? 'WrittenOff-Closed' :
  loanstate?.status === 12 ? 'Settled-Closed' :
   'Unknown') + 
 ' to ' + 
 (loanStatusOptions[selectedStatus] || selectedStatus) + 
(loanStatusOptions[selectedStatus] || selectedStatus 
   ? '' 
    :((formDataStatus === 4 ? 'WrittenOff' : '')  ? (formDataStatus === 4 ? 'WrittenOff' : '') :
   (loanstate?.status === 7 ? 'Active' : 'Pause'))) +  ':';
   

const handleChange = (e) => {
  setSelectedStatus(e.target.value);
};


const [preClosure,setPreClosure] = useState(false)

const handleCheckboxClick = (array, index) => {
  const notAdvEmis = array.filter((item) => !item.advanceEmi);

  if (notAdvEmis.length === index + 1 && array[index].status === 1) {
    setPreClosure(true);
  } else {
    setPreClosure(false);
  }

  setSelectedItems([]);
  setTotalEmiAmount(0);
  setOverdueCharges(0);
  setInterest(0);
  setChequeBounceCharges(0);

  const currentDate = new Date();
  if (document.getElementById(`${index}`).checked === false) {
    for (let i = 0; i < emiHistoryData?.length; i++) {
      document.getElementById(`${i}`).checked = false;
    }
    setSelectedItems([]);
    setSelectedEmiStatuses([]);
    setTotalEmiAmount(0);
    setOverdueCharges(0);
    setChequeBounceCharges(0);
    setInterest(0);
    return;
  }
  let shouldPreClose = false;
  let newSelectedItems = [];
  let newSelectedStatuses = [];
  let newPrincipleAmount = 0;
  let newPrinciple = 0;
  let newTotalEmiAmount = 0;
  let newOverdueCharges = 0;
  let newInterestAmount = 0;
  let newPaidInterest = 0;
  let newPaidPrinciple = 0;
  let newPaidBounce = 0;
  let newPaidPenalty = 0;
  let newChequeBounceCharges = 0;
  let newDiscountedBounce = 0;
  let newDiscountedPenalty = 0;
  let newRemainingAmountToBePaid = 0;

  for (let i = index; i >= 0; i--) {
    if (array[i].status !== 2 && array[i].status !== 4 && array[i].status !== 7) {
      document.getElementById(`${i}`).checked = true;
      // const dueDate = new Date(array[i].dueDate.split('/').reverse().join('/'));
      // const daysDiff = Math.floor((dueDate - currentDate) / (1000 * 60 * 60 * 24));
      if(notAdvEmis.length === index + 1 && array[index].status === 1){
        setPreClosure(true);
        const today = moment(); 
      const futureDates = array
        .map(item => moment(item.dueDate, 'DD/MM/YYYY'))
        .filter(date => date.isSameOrAfter(today, 'day'));
      const nextDueDate = moment.min(futureDates);    
      const itemsOnOrBeforeNextDue = array.filter(item => {
        const itemDate = moment(item.dueDate, 'DD/MM/YYYY');
        return itemDate.isSameOrBefore(nextDueDate, 'day');
      });
      
      const itemsAfterNextDue = array.filter(item => {
        const itemDate = moment(item.dueDate, 'DD/MM/YYYY');
        return itemDate.isAfter(nextDueDate, 'day');
      });
      
      const validItems = itemsAfterNextDue.filter(item => {
        return item.status !== 2 && item.status !== 8 && item.status !== 9;
      });

      const sumOnOrBefore = itemsOnOrBeforeNextDue
        .filter(item => item.status !== 2 && item.status !== 4)
        .reduce((sum, item) => {
          return sum + (parseFloat(item.remainingAmountToBePaid) || 0);
      }, 0);

      const sumAfter = validItems.reduce((sum, item) => {
      return sum + (parseFloat(item.principleAmount) || 0);
       }, 0);

      const interestAfter = validItems.reduce((sum, item) => {
      return sum + (parseFloat(item.interestAmount) || 0);
       }, 0);
      setTotalEmiAmount(Math.round(sumOnOrBefore) + Math.round(sumAfter));
      setForeCloseAmount(Math.round(sumAfter * 0.03));
      setFutureInterest(Math.round(interestAfter));
      newOverdueCharges += array[i].overdueCharges;
      newChequeBounceCharges += array[i].bounceCharges;
      newRemainingAmountToBePaid += array[i].remainingAmountToBePaid;
      }else{
      setPreClosure(false);
      newSelectedItems.push(array[i].emiId);
      newSelectedStatuses.push(array[i].status);
      newTotalEmiAmount += array[i].remainingAmountToBePaid;
      newOverdueCharges += array[i].overdueCharges;
      newInterestAmount += array[i].interestAmount;
      newPrinciple += array[i].principleAmount;
      newPaidInterest += array[i].paidInterest;
      newPaidPrinciple += array[i].paidPrinciple;
      newPaidBounce += array[i].paidBounceCharges;
      newPaidPenalty += array[i].paidOverdue;
      newChequeBounceCharges += array[i].bounceCharges;
      newDiscountedBounce += array[i].bounceDiscount ?? 0;
      newDiscountedPenalty += array[i].penaltyDiscount ?? 0;
      newRemainingAmountToBePaid += array[i].remainingAmountToBePaid;
      }
    }
  }

  // setPreClosure(preClosure);
  setSelectedItems(newSelectedItems);
  setSelectedEmiStatuses(newSelectedStatuses);
  setPrinciple(newPrinciple);
  setOverdueCharges(newOverdueCharges);
  setInterest(newInterestAmount);
  setPaidInterest(newPaidInterest);
  setPaidPrinciple(newPaidPrinciple);
  setPaidBounce(newPaidBounce);
  setPaidPenalty(newPaidPenalty);
  setChequeBounceCharges(newChequeBounceCharges);
  setDiscountedBounce(newDiscountedBounce);
  setDiscountedPenalty(newDiscountedPenalty);
  setRemainingAmountToBePaid(newRemainingAmountToBePaid);

};

    //
    // const newSelectedId = selectedItems.map((item) => item.emiId);
    // setSelectedId(newSelectedId);


    const [isEmiModalOpen, setIsEmiModalOpen] = useState(false);
    const statusPausedValue = loanstate?.status === 7 ? 1 : 7;

    const toggleEmiStatus = () => {
      setIsEmiModalOpen(!isEmiModalOpen);
     
    };
    const handlePausedClick = (statusPausedValue) => {
      
      const requestBody = {
        loanId:LoanId,
        newStatus: statusPausedValue
      };
        
      axiosInstance.post(`/loans/update-paused-status`,requestBody,{
        headers:{
      }
      }).then((res) => {
        if(res?.request?.status){
          handleSubmitActivity(); 
         }
        window.location.reload();
      
        
      }).catch((error) => {
        console.error('Error:', error.response ? error.response.data : error.message);
      });
    }
  const [reminders,setReminders]=React.useState(null)
  const [openmodal, setOpneModal] = useState(false);
  const [wittenOff, setWrittenOff] = useState(false);
  const [writtenLoandata,setwrittenLoandata]=useState(null)
  // 
  const toggled = () => setOpneModal(!openmodal);


  
  const WrittenOfftoggled = () =>{
     setWrittenOff(!wittenOff)

    axiosInstance.get(`loans/writtenOffLoanInfo?legacyLoanId=${legacyLoanId}`) // Replace with your API URL
    .then((res) => {
      // 
      setwrittenLoandata(res?.data?.data[0]); // Update state with API data
    })
    .catch((error) => {
      console.error("Error fetching loan data:", error);
    });
  }

  const [formData, setFormData] = useState({
    legacyLoanId:legacyLoanId,
    status:4,
    principleWrittenOff: "",
    interestWrittenOff: "",
    othercharges: "",
    legalCharges: "",
    writtenoffDate:''
  });
 

  //  const handleChangeWritterOff = (e) => {
  //   setFormDataStatus(formData.status)
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,  
  //   });
  // };

  // Function to handle input changes
 const handleChangeWritterOff = (e) => {
    const { name, value } = e.target;
    setFormDataStatus(formData.status)
    setFormData({
      ...formData,
      [name]: value,
    });
  };



  const [isModalOpencheck, setIsModalOpencheck] = useState(false);
  const toggleModalcheck = () => {
    setIsModalOpencheck(!isModalOpencheck);
  };

  const isStatusDisabled = (statusKey) => {
    const statusValue = parseInt(statusKey);
   
    if (loanstate?.status !== 8) {
      return statusValue !== 8; 
    }
    return statusValue === 8; 
  };


  // const WrittenOffStatusDisabled = (statusKey) => {
  //   const statusValue = parseInt(statusKey);
   
  //   if (loanstate?.status !== 4) {
  //     return statusValue !== 4; 
  //   }
  //   return statusValue === 4; 
  // };
 

  const handleYesClick = () => {
    
   
    const requestBody = {
      loanId:LoanId,
       newStatus: parseInt(selectedStatus, 10)
    };
     
    axiosInstance.post(`/loans/update-loan-status`,requestBody,{
      headers:{
    }
    }).then((res) => {
      if (res.status === 200) {
        handleSubmitActivity()
      }
      window.location.reload();
    }).catch((error) => {
      console.error('Error:', error.response ? error.response.data : error.message);
    });
  }


  const handleYesClickwrittenOff = () => {
    
   if(!formData.writtenoffDate || !activityNotes.trim()){
     window.alert('Please fill the required fields.')
     const isDateEmpty = !formData.writtenoffDate;
     const isNotesEmpty = !activityNotes.trim();
      setWrittenoffDateError(isDateEmpty);
     setRemarksError(isNotesEmpty);
   }else{
     
    axiosInstance.post(`loans/updateWrtittenOff`,formData,{
      headers:{
    }
    }).then((res) => {
      if (res?.data?.data?.success === true) {
      handleSubmitActivity()
      window.location.reload();
      }else{
         alert('Oops. There is an issue at our end. Please contact our support team. ')
      }
     
     
    }).catch((error) => {
      alert("Oops. There is an issue at our end. Please contact our support team.");
      console.error('Error:', error.response ? error.response.data : error.message);
    });
  }
  }
   
  
const [remainingAmount,setRemainingAmount] = useState(0)

const [discountedBounce,setDiscountedBounce] = useState("")
const [paidBounce,setPaidBounce] = useState("")
const [paidPenalty,setPaidPenalty] = useState("")
const [discountedPenalty,setDiscountedPenalty] = useState("")
const [selfie,setSelfie] = useState(null)
// Persist URL-param IDs to Redux so sub-components (LoanActivity) can read them in the new window
useEffect(() => {
  if (LoanId || legacyLoanId) {
    dispatch({ type: appContextConstants.SET_LOAN_CONTEXT, payload: {
      loanid: LoanId || null,
      legacyLoanId: legacyLoanId || null,
    }});
  }
}, [LoanId, legacyLoanId, dispatch]);

useEffect(() => {
  // Initial load: dispatch necessary requests once on mount
  getPreClosureAmount();
  // checkRefundStatus();
  if (!activityState) {
    dispatch(userActions.getLoanActivity(getActivityUrl, user));
  }

  dispatch(userActions.fetchLoanDetails(urlUsers, user));
  dispatch(userActions.fetchCallDetails(callDetailsUrl, user));
  dispatch(userActions.getEmiHistory(emihistoryUrl, user));

  if (getReminderState) {
    setReminders(getReminderState);
  }
}, [dispatch, getActivityUrl, urlUsers, callDetailsUrl, emihistoryUrl, getReminderState, user]);

// Keep local state in sync when redux state updates (no new network requests here)
useEffect(() => {
  if (loanstate) setLoanDetails(loanstate);
}, [loanstate]);

// Dispatch context IDs once loanDetails is populated (must be in useEffect, not render body)
useEffect(() => {
  if (loanDetails.applicationId) {
    dispatch({ type: appContextConstants.SET_ACTIVITY_CONTEXT, payload: { activityAppId: loanDetails.applicationId } });
  }
  if (loanDetails.userId) {
    dispatch({ type: appContextConstants.SET_REPAYMENTS_CONTEXT, payload: { repaymentsUserId: loanDetails.userId } });
  }
}, [loanDetails, dispatch]);

useEffect(() => {
  if (callstate) setTableData(callstate);
}, [callstate]);

useEffect(() => {
  if (getReminderState) setReminders(getReminderState);
}, [getReminderState]);

useEffect(() => {
  if (emiHistoryState) {
    const totalRemainingAmount = emiHistoryState?.reduce(
      (acc, item) => acc + (parseFloat(item?.remainingAmountToBePaid) || 0),
      0
    );
    const paidPrincipal = emiHistoryState?.reduce(
      (acc, item) => acc + (parseFloat(item?.paidPrinciple) || 0),
      0
    );
    const paidInterest = emiHistoryState?.reduce(
      (acc, item) => acc + (parseFloat(item?.paidInterest) || 0),
      0
    );
    setPrinciplePaid(paidPrincipal);
    setInterestPaid(paidInterest);
    setRemainingAmount(totalRemainingAmount);
    setEmiHistory(emiHistoryState);
  }
}, [emiHistoryState]);

// Load selfie only when we have a valid selfie path
useEffect(() => {
  if (loanDetails?.selfieUrl) {
    const url = `/file/url-content?path=${loanDetails.selfieUrl}`;
    axiosInstance
      .get(url, {
        headers: {
        },
      })
      .then((res) => {
        setSelfie(res?.data?.data);
      })
      .catch(() => {});
  }
}, [loanDetails?.selfieUrl, user]);



  const [isDialogOpen, setIsDialogOpen] = useState(false);

const handleOpenDialog = () =>{ setIsDialogOpen(true);

    dispatch(userActions.getLoanActivity(getActivityUrl,user));

}
const handleCloseDialog = () => setIsDialogOpen(false);


let totalCount = 0;
let countStatus2 = 0;
if (emiHistoryData) {
    emiHistoryData.forEach((item) => {
      totalCount++;
      if (item.status === 2 || item.status === 4) {
        countStatus2++;
      }
    });
  }
  const [popUp, setpopUp] = useState(false);
   const handleMobileDetails=()=>{
    setpopUp(!popUp);
    
  }
  const toggleModal = (item) => {
    setIsModalOpen(!isModalOpen);
    setAmount(item?.emiAmount)
    setEmiid(item?.emiId)

  };
  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN'); 
  }

  const  togglePaymentLinkModal = ()=>{
    setShowPaymentLinkModal(!showPaymentLinkModal)
  }
  const copyToClipboard = () => {
    navigator.clipboard.writeText(paymentLink);
    alert('Payment link copied to clipboard!');
  };
  const generatelink = ()=>{
    if(remarks === null){
      alert("Please Enter Remarks")
    }else{
      const data = {
        loanId:LoanId,
        amount:amount,
        reason:1,
        emiIds:[emiId],
        remarks:remarks,
      };
      const createUrl = `/loan-repayment/payment-link`;
  
      axiosInstance.post(createUrl,data,{
        headers:{
      }
      }).then((res)=>{
        // setPaymentLink(res?.data?.data)
        // setShowPaymentLinkModal(true);
        if (res?.data?.data) alert('Link generated successfully and customer notified.')
      })
    }

  }
  const [MandateModal, setMandateModal] = useState(false);


  const toggleMandateDetails = () => setMandateModal(!MandateModal);
  const [applicantChecked, setApplicantChecked] = useState(false);
  const [coApplicantChecked, setCoApplicantChecked] = useState(false);

  const handleApplicantCheckboxChange = () => {
    setApplicantChecked(true);
    setCoApplicantChecked(false);
  };

  const handleCoApplicantCheckboxChange = () => {
    setApplicantChecked(false);
    setCoApplicantChecked(true);
  };

  useEffect(() => {
  if (loanDetails?.mandateDetails) {
    setCustomerId(loanDetails.mandateDetails.customerId || '');
    setTokenId(loanDetails.mandateDetails.tokenId || '');
    setUmrn(loanDetails.mandateDetails.digioUmrn || '');
    setMandateType(loanDetails.mandateDetails.type || '');
  }
}, [loanDetails]);

 const handleUpdateMandate = () =>{ 
          setSubmitAttempted(true);

          if (!customerId || !tokenId) {
            return; 
          }
            const data = {
            mandateType: loanDetails.mandateDetails.mandateType,
            customerName: loanDetails.mandateDetails.customerName,
            customerEmail: loanDetails.email,
            contact: loanDetails.mobile,
            userId: loanDetails.userId,
            applicationId: loanDetails.applicationId,
            customerId: customerId,
            mandateId: loanDetails.mandateDetails.mandateId,
            paymentId: loanDetails.mandateDetails.paymentId,
            tokenId: tokenId,
            mandateStatus: 3,
            remark: ""
          };
        const updateUrl = `/loan-repayment/update-mandate-details`;
      
          axiosInstance.post(updateUrl,data,{
            headers:{
          }
          }).then((res)=>{
            if(res?.data?.message === "Successful"){
              alert("updated successfully")
              window.location.reload()
            }
        
          }).catch((error)=>{
            alert(error?.response?.data?.message)
          })
     }

  const updateMandate =()=>{
    const data = {
      loanId:LoanId,
      mandatePrimary:applicantChecked ? "1":"2",
    
    };
    const updateUrl = `/loans/update-mandate`;
  
      axiosInstance.post(updateUrl,data,{
        headers:{
      }
      }).then((res)=>{
        if(res?.data?.message === "Successful"){
          alert("updated successfully")
          window.location.reload()
        }
    
      }).catch((error)=>{
        alert(error?.response?.data?.message)
      })
  }

  const openCustomerDashboard = (mobile) => {
    dispatch(
      userActions.openCustomerDashboard(customerDashboardLoginUrl, user, mobile)
    );
  };


  const handleUser = () => {

    const Id = loanDetails.userId;
    dispatch({ type: appContextConstants.SET_REPAYMENTS_CONTEXT, payload: {
      repaymentsUserId: Id,
      repaymentsAppId: loanDetails.applicationId,
    }});
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status: 'Disbursed' } });
    dispatch({ type: appContextConstants.SET_ACTIVITY_CONTEXT, payload: { activityAppStatus: 'Disbursed' } });
    const ckycUrl=`/ckyc/details?userId=${Id}`;
  const profileUrl=`/summary/user?id=${Id}&applicationId=${loanDetails.applicationId}&status=Disbursed`;
  const digilockerUrl=`/digilocker/details?applicationId=${loanDetails.applicationId}&userId=${Id}`;
  const panUrl=`/application/pan-details?userId=${Id}&applicationId=${loanDetails.applicationId}`;
  const bankSelfieUrl=`/integrations/details?applicationId=${loanDetails.applicationId}&userId=${Id}`;
  const uploadedFileUrl=`/users/documents/admin?userId=${Id}`
  const getActivityUrl=`/audit?applicationId=${loanDetails.applicationId}`
const urlForBankSelfie=`/integrations/application-profile?applicationId=${loanDetails.applicationId}`
  //cibil
  const urlCIBIL = `/cibil/report?userId=${Id}`

  const urlIncomeProfile=`/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${loanDetails.applicationId}`
   
    dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile,user));
      const getFoirRefUrl=`/admin/application/additional-info?applicationId=${loanDetails.applicationId}`
  dispatch(userActions.getFoirDetails(getFoirRefUrl,user));
        dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
  
    dispatch(userActions.getCkycDetails(ckycUrl,user));
    dispatch(userActions.getCibilDetails(urlCIBIL));
    dispatch(userActions.getPanStatus(panUrl));
    dispatch(userActions.getBankSelfieDetails(bankSelfieUrl,user));
    dispatch(userActions.getDigiLocker(digilockerUrl,user));
    dispatch(userActions.getProfileDetails(profileUrl));
    dispatch(userActions.getUploadedFiles(uploadedFileUrl,user));
    dispatch(userActions.getLoanActivity(getActivityUrl,user));


    const coappId = Array.isArray(loanDetails.coapplicantId) ? loanDetails.coapplicantId[0] : loanDetails.coapplicantId;
    const baseParams = `userId=${Id}&appId=${loanDetails.applicationId}&status=Disbursed`;
    const profilePath = coappId
      ? `/status/disbursed/profile?${baseParams}&coapplicantId=${coappId}`
      : `/status/disbursed/profile?${baseParams}`;
    window.open(profilePath, "_blank")

    
    
  };




    async function handleSubmitActivity(){

     
      const now = new Date();
  const dateTime = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now
    .getDate()
    .toString()
    .padStart(2, '0')} ${now.getHours().toString().padStart(2, '0')}:${now
    .getMinutes()
    .toString()
    .padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
      const activityBody={
          "legacyLoanId" :legacyLoanId,
          "loanId" :LoanId,
          "userId": repaymentsUserId,
          "notes": activityNotes && defaultStatus ? `${defaultStatus} ${activityNotes} ` : (activityNotes || defaultStatus || 'null'),
          "date": dateTime,
          "amount":''
      }
       await dispatch(userActions.submitActivity(urlAddActivity,activityBody,user))
      setActivityNotes('')
    }
    const [agreementModal, setAgreementModal] = useState(false);
    const [agreementUrl,setAgreementUrl] = useState(null)
    const [sanctionLetterModal, setSanctionLetterModal] = useState(false);
    const [demandLetterModal,setDemandLetterModal] =useState(false)
    const [legalLetterModal,setLegalLetterModal] =useState(false)
    const [sanctionUrl,setSanctionUrl] = useState(null)
    const [demandletter,setDemandLetter] = useState(null)
    const [legalletterGenarate,setLegalLetterGenarate] = useState(null)
    const [legalLetterErrors, setLegalLetterErrors] = useState({});

    const toggleAgreement = () => {
      const url = `/file/url-content?path=${loanDetails?.agreementUrl}`
      axiosInstance
          .get(url, {
            headers: {
            },
          })
          .then((res)=>{
            setAgreementUrl(res?.data?.data)
            })
            setAgreementModal(!agreementModal)
    };

    const toggleSanctionLetter = () => {
      const url = `/file/url-content?path=${loanDetails?.sanctionLetterUrl}`
      axiosInstance
          .get(url, {
            headers: {
            },
          })
          .then((res)=>{
            setSanctionUrl(res?.data?.data)
            })
            setSanctionLetterModal(!sanctionLetterModal)
    };


 const handleFetchAndSend =  () => {
    const userId = repaymentsUserId;
     axiosInstance.get('/overdues/getDemandLetter', {
        params: {legacyLoanId:legacyLoanId , userId:userId },
        headers: {
        }
      }).then((res)=>{
           const source = res?.data?.data
     if(res.status === 200 && res?.data?.data?.length > 0)  {  
      axiosInstance.post('/pdf-generations', 
             {
          userName: source?.[0]?.userName,
        userAddress: source?.[0]?.userAddress,
        date: moment().format('DD-MM-YYYY'),
        loanAmount: source?.[0]?.loanAmount,
        emiAmount: source?.[0]?.emiAmount,
        loanDate: source?.[0]?.loanDate ? moment(source[0].loanDate).tz("Asia/Kolkata").format('DD-MM-YYYY') : '00-00-0000',
        tenure: source?.[0]?.tenure,
        paidEmiCount: source?.[0]?.paidEmiCount,
        firstEmiDueDate: source?.[0]?.firstEmiDueDate ? moment(source[0].firstEmiDueDate).tz("Asia/Kolkata").format('DD-MM-YYYY') : '00-00-0000',
        firstEmiPaidDate: source?.[0]?.firstEmiPaidDate ? moment(source[0].firstEmiPaidDate).tz("Asia/Kolkata").format('DD-MM-YYYY') : '00-00-0000',
        lastEmiPaidDate: source?.[0]?.lastEmiPaidDate ? moment(source[0].lastEmiPaidDate).tz("Asia/Kolkata").format('DD-MM-YYYY') : '00-00-0000',
        overdueEmiCount: source?.[0]?.overdueEmiCount,
        overdueAmount: source?.[0]?.overdueAmount,
        penalty: source?.[0]?.penalty,
        principleDue: source?.[0]?.principleDue,
            },
                 {
        headers: {
        },
      }).then((res) => {
         setDemandLetter(res?.data?.data)
         setDemandLetterModal(!demandLetterModal)
      }).catch((error)=>{
         alert(`Please contact support team: ${error?.response?.data?.error}`)
      })
    
    }
    else{
      alert("Please contact support team!,data is not fetching ")
      setDemandLetterModal(demandLetterModal)
    }
     }).catch((error)=>{
        alert(`Please contact support team: ${error?.response?.data?.error}`)
        setDemandLetterModal(demandLetterModal)
      })
   
    
  }


   const openLegalLetterModal = () => {
    if (loanstate?.status === 3) setLegalLetterModalOpen(true);
  };

  const closeLegalLetterModal = () => {
  setLegalLetterModal(false);
  setLegalLetterModalOpen(false);
  document.body.style.overflow = 'auto';
};

  const handleLegalLetterInputChange = (e) => {
    const { name, value } = e.target;
    setLegalLetter((prev) => ({ ...prev, [name]: value }));
  };

  


    const submitLegalLetter = () => {
      const errors = {};

      const userId = repaymentsUserId;
      if (!legalLetter.mandateRaisedDate) errors.mandateRaisedDate = 'Mandate Raised Date is required';
      if (!legalLetter.mandateFailedDate) errors.mandateFailedDate = 'Mandate Failed Date is required';
      if (!legalLetter.softNoticeDate) errors.softNoticeDate = 'Soft Notice Date is required';
      if (!legalLetter.overdueEmiAmount) errors.overdueEmiAmount = 'Overdue EMI Amount is required';
      if (!legalLetter.penaltyAndBounceCharges) errors.penaltyAndBounceCharges = 'Penalty + Bounce Charges is required';
      if (!legalLetter.totalOutstanding) errors.totalOutstanding = 'Total Outstanding Amount is required';
      if (!legalLetter.mandateFailedCount) errors.mandateFailedCount = 'Mandate Failed Count is required';
      if (!legalLetter.mandateFailedReason) errors.mandateFailedReason = 'Mandate Failed Reason is required';

      setLegalLetterErrors(errors);

      if (Object.keys(errors).length > 0){ return;}

      axiosInstance.post('/pdf-generations/legal',
        {
          userId,
          loanId: legacyLoanId,
          notificationSentDate: legalLetter.softNoticeDate,
          mandatesPresentedDate: legalLetter.mandateRaisedDate,
          mandatesFailedDate: legalLetter.mandateFailedDate,
          overdueAmount: Number(legalLetter.overdueEmiAmount),              
          penaltyAndBounceCharges: Number(legalLetter.penaltyAndBounceCharges), // ✅ converted
          failureReason: legalLetter.mandateFailedReason,
          mandatesPresentedCount: Number(legalLetter.mandateFailedCount),
          totalOutstandingIncludingFutureEmis: Number( legalLetter.totalOutstanding)
        },
        {
          headers: {
          },
        }
      ).then((res) => {
        setLegalLetterGenarate(res?.data?.data)
        setLegalLetterModalOpen(false);
        setLegalLetterModal(true);
      }).catch((error) => {
        alert(`Please contact support team}`);
      });

    };

    const getAAConsentDetails = async () => {
      const url = `/bank-sdk/aa-consent-details?userId=${loanDetails?.userId}&applicationId=${loanDetails?.applicationId}`
      try {
        const res = await axiosInstance.get(url)
        const response = res?.data
        const consentDate = response?.data?.createdAt?.split(" ")?.[0]
        setConsentDate(consentDate)
        // 
      } catch (e) {
      }
    };

    const getPreClosureAmount = async () => {
      const url = `/loan-repayment/preclose-amount`
      const body = { loanId: LoanId }
      try {
        const res = await axiosInstance.post(url,body, {
          headers: {
            },
          })
        const response = res?.data
        setPreClosureAmount(response?.data)
        setPreClosureCharges(response?.preClosureCharges)
        // 
      } catch (e) {
      }
    };
    const getProgressColor = (completedPercentage) => {
      if (completedPercentage === 100) return "#12B76A";      // Green – fully completed
      if (completedPercentage >= 50) return "#F8A31F";        // Orange – halfway
      return "#D22129";                                       // Red – low completion
    };

    const handleFromDate = (event) => {
      if (event && event.format) {
        const f = event.toDate();
        setFromDate(f);

        if (toDate && f.getTime() >= toDate.getTime()) {
          setError("To Date cannot be less than From Date");
        } else {
          setError("");
        }
      }
    };

    const handleToDate = (event) => {
      if (event && event.format) {
        const t = event.toDate();
        setToDate(t);

        if (fromDate && fromDate.getTime() >= t.getTime()) {
          setError("To Date cannot be less than From Date");
        } else {
          setError("");
        }
      }
    };

    const disableDownload = !fromDate || !toDate || error !== "";

    const downloadBankStatementExcel = async (excelUrl) => {
      const path = excelUrl?.split(".com/")[1]
      try {
        const url = `/file/url-content?path=${path}`
        const res = await axiosInstance(url,
          {
            headers: {
            },
          })
        
        const response = res?.data
        const fileUrl = response?.data
        // 
        const link = document.createElement("a")
        link.href =  fileUrl
        link.setAttribute('download', 'statement.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }catch (e) {
        alert("Failed to download excel", e.message);
      }finally{
        setStatementLoading(false)
        setOpenBankStatementDialog(false)
      }
    }


    const handleDownloadBankStatement = async () => {
      setStatementLoading(true)
      try {
        const formatedFromDate= fromDate.getDate() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getFullYear();
        const formatedToDate= toDate.getDate() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getFullYear();
        // ;
        const url = `/bank-sdk/recurring-aa-data`
        const body = {
          userId: loanDetails?.userId,
          applicationId: loanDetails?.applicationId,
          fromDate: formatedFromDate,
          toDate: formatedToDate
        }
        const res = await axiosInstance.post(url,body, {
          headers: {
            },
          })
        
          const response = res?.data
          // 
          if(response?.data?.error){
            alert(response?.data?.error)
            setStatementLoading(false)
            return
          }
          await downloadBankStatementExcel(res?.data?.data?.analysisExcelReport)
          
        } catch (e) {
          alert("Failed to download", e.message);
          setStatementLoading(false)
        }
    }
    const handleClose = (event) => {
      setOpenActions(false);
    };

    const handleDocumentClose = (event) => {
      setOpenDocuments(false);
    };

    const handleCollectClose = (event) => {
      setOpenCollections(false);
    };


    // BUILD ACTION OPTIONS BASED ON CONDITIONS
    const actionOptions = [];

    // 1️⃣ MOVE TO LEGAL / REMOVE LEGAL
    if (
      loanstate?.status !== 2 &&
      // loanstate?.status !== 6 &&
      (decode.role === "finance" || decode.role === "admin" || decode.role === "collection")
    ) {
      actionOptions.push({
        label: loanstate?.status === 8 ? "Remove Legal" : "Move to Legal",
        onClick: toggled,
        disabled:
          loanstate?.status === 2 ||
          // loanstate?.status === 6 ||
          loanstate?.status === 7
      });
    }

    // 2️⃣ MOVE TO WRITEOFF
    if (
      loanstate?.status !== 2 &&
      // loanstate?.status !== 6 &&
      (decode.role === "finance" || decode.role === "admin" || decode.role === "collection")
    ) {
      actionOptions.push({
        label: "Move to WriteOff",
        onClick: WrittenOfftoggled,
        disabled: loanstate?.status === 7 || loanstate?.status === 4
      });
    }

    // Pause / UnPause
    if (
      loanstate?.status !== 2 &&
      loanstate?.status !== 6 &&
      (decode.role === "finance" ||  decode.role === "admin")
    ){
      actionOptions.push({
        label: loanstate?.status === 7 ? "Unpause Loan" : "Pause Loan",
        onClick: toggleEmiStatus,
        disabled: loanstate?.status === 2 
      });
    }

    // 3️⃣ BANK STATEMENT 
    if (
      loanstate?.status !== 2 &&
      // loanstate?.status !== 6 &&
      loanstate?.status !== 9 &&
      (decode.role === "finance" ||  decode.role === "admin" || decode.role === "collection")
    ){
      actionOptions.push({
        label: "Download Bank Statement",
        onClick: () => {
          setOpenBankStatementDialog(true)
          getAAConsentDetails()
        },
        disabled: false
      });
    }

    if (
      loanstate?.status !== 2 &&
      loanstate?.status !== 6 &&
      loanstate?.status !== 9 &&
      (decode.role === "finance" || (decode.role === "collection" && !loanDetails?.refundRaised) || decode.role==='admin')
    ){
      actionOptions.push({
        label: "Request Refund",
        onClick: () => {
          setRefundModalOpen(true);
        }
      });
    }

  const documentsOptions = [
    {
      label: 'Mandate Details',
      disabled: false,
      onClick: toggleMandateDetails
    },
    {
      label: 'Loan Agreement',
      disabled: !loanDetails?.agreementUrl,
      onClick: toggleAgreement
    },
    {
      label: 'Sanction Letter',
      disabled: !loanDetails?.sanctionLetterUrl,
      onClick: toggleSanctionLetter
    },
    {
      label: 'Demand Letter',
      disabled: loanstate?.status !== 3 && loanstate?.status !== 4,
      onClick: handleFetchAndSend
    },
    {
      label: 'Legal Letter',
      disabled:loanstate?.status !== 3 && loanstate?.status !== 4,
      onClick: openLegalLetterModal
    },
  ];
  const [modal, setModal] = useState(false);
  const [mandateTokenId, setMandateTokenId] = useState("")

  const [mandateCustomerId, setMandateCustomerId] = useState("")

  const [name, setName] = useState("")

  const [email, setEmail] = useState("")

  const [contact, setContact] = useState("")

  const [mandateLegacyLoanId, setMandateLegacyLoanId] = useState("")

  const [mandateNotes, setMandateNotes] = useState("")
  const [mandateDiscountAmount, setMandateDiscountAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState(null)
  const [presentMandateLoading, setPresentMandateLoading] = useState(false)
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpMobile, setOtpMobile] = useState('');
  const [otpLoading, setOtpLoading] = useState(false);


  const toggleMandate = () => {
      setModal(!modal)
      setMandateTokenId(tokenId)
      setMandateCustomerId(customerId)
      setMandateLegacyLoanId(legacyLoanId)

      if (modal) { // If closing modal, reset states
          setMandateTokenId("")
          setMandateCustomerId("")
          setName("")
          setEmail("")
          setContact("")
          setMandateLegacyLoanId("")
          setPresentMandateLoading(false)
          setMandateNotes("")
          setMandateDiscountAmount("");
          setError("");
          setMaxAmount(null);
          setOtpSent(false);
          setOtpVerified(false);
          setOtp('');
          setOtpMobile('');
      } else { // If opening modal, fetch tokens
          const data = {
              applicationId: loanDetails?.applicationId,
              userId: loanDetails?.userId,
          }
          if(loanDetails?.mandateDetails?.type !== "Digio"){
              const tokenUrl = `/nach/razorpay-tokens`
          axiosInstance.post(tokenUrl, data, {
              headers: {
              }
          }).then((res) => {
              const responseData = res?.data?.data;
              const tokenFound = responseData.find((responseItem) => responseItem.id === tokenId);
              if (tokenFound) {
                  setMaxAmount(tokenFound.max_amount / 100);
              } else {
                  alert("No matching token found for this EMI.");
                  setMaxAmount(0); // Set to 0 if no token or no max_amount
              }

          }).catch((error) => {
              alert(error?.response?.data?.message || "Error fetching Razorpay tokens.");
          });
          }
        
      }
    }
    const maskMobileNumber = (mobile) => {
      if (!mobile || mobile.length < 4) return mobile;
      const last4 = mobile.slice(-4);
      return `******${last4}`;
    };

    const createOTP = async (mobile) => {
      try {
        setOtpLoading(true);
        const response = await axiosInstance.post(
          `/login/create-otp`,
          { mobile },
          {
            headers: {
              accept: '*/*',
              'Content-Type': 'application/json',
            },
          }
        );
        setOtpSent(true);
        setOtpMobile(mobile);
        setOtpLoading(false);
        return true;
      } catch (err) {
        console.error('create-otp error', err);
        alert(err?.response?.data?.message || 'Failed to send OTP');
        setOtpLoading(false);
        return false;
      }
    };

    const verifyOTP = async (mobile, otp) => {
      try {
        setOtpLoading(true);
        const response = await axiosInstance.post(
          `/login/verify-otp`,
          { mobile, otp },
          {
            headers: {
              accept: '*/*',
              'Content-Type': 'application/json',
            },
          }
        );
        setOtpVerified(true);
        setOtpLoading(false);
        return true;
      } catch (err) {
        console.error('verify-otp error', err);
        alert(err?.response?.data?.message || 'Invalid OTP');
        setOtpLoading(false);
        return false;
      }
    };

    const handleSubmitMandate = async () => {
      if (!otpSent) {
        const mobile = "7675997802";
        await createOTP(mobile);
      } else if (!otpVerified) {
        if (!otp || otp.length !== 6) {
          alert('Please enter a valid 6-digit OTP');
          return;
        }
        const verified = await verifyOTP(otpMobile, otp);
        if (verified) {
          presentMandate();
        }
      }
    };

    const presentMandate = () => {
      setPresentMandateLoading(true)
      if(loanDetails?.mandateDetails?.type !== "Digio"){
      const url = `/loan-repayment/now`;

      const data = {
          emiId: selectedItems,
          amount: "",
          discount: "",
          tokenId: tokenId,
          customerId: customerId,
          name: loanDetails.firstName + " " + loanDetails.lastName,
          emailId:loanDetails.email,
          contact: loanDetails.mobile,
          legacyLoanId: legacyLoanId,
          notes: mandateNotes,
          maxAmount: maxAmount
      }
      axiosInstance.post(url, data, {
          headers: {
          }
      }).then((res) => {
          setPresentMandateLoading(false)
          setOtpSent(false);
          setOtpVerified(false);
          setOtp('');
          setOtpMobile('');
          alert(res?.data?.message);
          setTimeout(() => window.location.reload(true), 200);

      }).catch((error) => {
          const errorMessage = Array.isArray(error?.response?.data?.message)
              ? error.response.data.message.join(', ')
              : error?.response?.data?.message || 'An unknown error occurred.';
          alert(errorMessage);
          setPresentMandateLoading(false)
          setOtpSent(false);
          setOtpVerified(false);
          setOtp('');
          setOtpMobile('');
      });
      }else{
      const url = `/loan-repayment/now-digio`;

      const data = {
          emiId: selectedItems,
          amount: "",
          discount: "",
          tokenId: tokenId,
          customerId: customerId,
          name: loanDetails.firstName + " " + loanDetails.lastName,
          emailId:loanDetails.email,
          contact: loanDetails.mobile,
          legacyLoanId: legacyLoanId,
          notes: mandateNotes,
          maxAmount: maxAmount
      }
      axiosInstance.post(url, data, {
          headers: {
          }
      }).then((res) => {
          setPresentMandateLoading(false)
          setOtpSent(false);
          setOtpVerified(false);
          setOtp('');
          setOtpMobile('');
          alert(res?.data?.message);
          setTimeout(() => window.location.reload(true), 200);

      }).catch((error) => {
          const errorMessage = Array.isArray(error?.response?.data?.message)
              ? error.response.data.message.join(', ')
              : error?.response?.data?.message || 'An unknown error occurred.';
          alert(errorMessage);
          setPresentMandateLoading(false)
          setOtpSent(false);
          setOtpVerified(false);
          setOtp('');
          setOtpMobile('');
      });
      }
      
    }

    const createRefund =()=>{
if ( !refundReason.trim() || emails.length === 0|| !courseName.trim()) {
    alert('Please fill all required fields: Reason, and at least one email.');
    return;
  }

  const requestBody = {
    loanId: legacyLoanId,
    userId: loanDetails.userId,                    
    emails: Array.from(new Set([...(emails || []), ...(loanDetails?.refundPocs || loanDetails?.refundpocs || [])])),
    instituteId: loanDetails.instituteId,        
    courseName: courseName.trim(),
     reasonForRefund: refundReason.trim(),
    sendEmail:sendEmail? 1:0
  };

  axiosInstance.post(`/refunds/create-refund-details`, requestBody, {
  })
  .then((res) => {
    if (res.data.success || res.status === 200) {
      alert("Refund request submitted successfully");
      setRefundModalOpen(false);
      setEmails([]);
      setCurrentEmail('');
      setCourseName('');
    }
  })
  .catch((err) => {
    alert("Failed to submit refund request. Please try again.");
    console.error(err);
    
  });
    }

    return(
        <div style={{  backgroundColor:"white"}}>
        <div style={{ width:"100%",height:'100%',backgroundColor:"white", paddingBottom:'30px'}}>
                <div style={{ padding: '12px 12px', display: 'flex',flexDirection:'row', justifyContent: 'space-between', alignItems: 'center' }}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={loanactive} alt="loan active" />
        <span style={{ marginLeft: '10px',  fontSize: '14px', fontWeight:'600',  color:'#667085', }}>Loan Profile</span>
        <ArrowForwardIosIcon sx={{fontSize:'12px', ml:1}} color='secondary'/>
        <span style={{ marginLeft: '10px', color: '#D32028', fontWeight: '600', fontSize: '14px' }}>{legacyLoanId}</span>
        <ArrowForwardIosIcon sx={{fontSize:'12px', ml:1}} color='secondary'/>
        <span
          style={{
            backgroundColor: statusStyles[loanstate?.status]?.bg || "#59761A",
            fontWeight:'600',
            fontSize: "14px",
            marginLeft: '10px', 
            color : statusStyles[loanstate?.status]?.color || "#fff",
            padding: "0px 16px 0px 16px",
            borderRadius: '20px',
            lineHeight: 1.8
          }}
        >
         <InfoOutlinedIcon style={{fontSize:'14px', color : statusStyles[loanstate?.status]?.color || "#fff"}}/> {`${LoanStatus[loanstate?.status]}`} {loanstate?.status === 3 &&  `:  ₹ ${formatNumberWithCommas(loanDetails.overdue) || 0}`}  {loanstate?.status === 4 && (loanDetails?.writtenOffDate ? ` on ${loanDetails.writtenOffDate}` : '')}
        </span>
    </div>
    <div  style={{display: 'flex',flexDirection:'row', justifyContent: 'space-between', gap:'24px'}}>
      <div>
        
 {loanDetails?.refundRaised &&(
    <span
      style={{
        backgroundColor: '#ECFDF3',
        color: '#027A48',
        padding: '8px 8px',
        borderRadius: '10px',
        fontSize: '12px',
        fontWeight: 500,
        marginRight:'10px',
        gap: '6px',
        border: '1px solid #A6F4C5',
        fontFamily: 'Inter',
        whiteSpace: 'nowrap'
      }}
    >
      <CheckIcon style={{ fontSize: '14px' }} />
      Refund request done
    </span>
  )}
        </div>
    <div
      onMouseEnter={() => setOpenActions(true)}
      onMouseLeave={() => setOpenActions(false)}
      style={{ display: "inline-block" }}
    >


      
      <MuiButton 
        ref={anchorRef}
        id="actions"
        variant="outlined"
        color='secondary'
        onClick={() => setOpenActions((prev) => !prev)}
        style={{
          color: '#416CC7',
          textTransform: "none",
        }}
        // endIcon={<ArrowDropDownIcon />}
      >
        Actions
      </MuiButton>

      <Popper
        sx={{ zIndex: 1 }}
        open={openActions}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem>
                  {actionOptions.map((item, idx) => (
                    <MenuItem
                      key={idx}
                      disabled={item.disabled}
                      style={{  
                        fontSize: '14px',
                        color: item.disabled ? '#999999' : '#314158', 
                        fontFamily:'inherit',
                        opacity: item.disabled ? 0.6 : 1,
                        textDecoration: item.disabled ? 'none' : '',
                        cursor: item.disabled ? 'not-allowed' : 'pointer'
                      }}
                      onClick={(e) => {
                        handleClose();
                        if (!item.disabled) item.onClick(e);
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
    
    <div
     onMouseEnter={() => setOpenDocuments(true)}
      onMouseLeave={() => setOpenDocuments(false)}
      style={{ display: "inline-block" }}
    >
      <MuiButton 
        ref={documentRef}
        id={'docs'}
        onClick={() => setOpenDocuments((prev) => !prev)}
        variant="outlined"
        style={{
          color: '#416CC7',
          // backgroundColor: "#d32028",
          textTransform: "none",
          borderColor:'#AEBBD7'
        }}
        startIcon={<TextSnippetIcon />}
        // endIcon={<ArrowDropDownIcon />}
      >
        Docs
      </MuiButton>

      <Popper
        sx={{ zIndex: 1 }}
        open={openDocuments}
        anchorEl={documentRef.current}
        placement="bottom-start"
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleDocumentClose}>
                <MenuList autoFocusItem>
                  {documentsOptions.map((item, idx) => (
                    <MenuItem
                      key={idx}
                      disabled={item.disabled}
                      style={{  fontSize: '14px',color:'#314158',fontFamily:'inherit' }}
                      onClick={(e) => {
                        handleDocumentClose();
                        if (!item.disabled) item.onClick(e);
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
    <div>
      <MuiButton
        onClick={handleOpenDialog}
        style={{
          color: "white",
          backgroundColor: "#d32028",
          textTransform: "none",
        }}
        // startIcon={ <img
        //   style={{  width: "20px",  }}
        //   src={Activity}
        //   alt="activity"
        // />}
        startIcon={<AutoGraphIcon/>}
      >
        Activity
      </MuiButton>
    </div>
      

      <Dialog
        fullScreen
        open={isDialogOpen}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            width: "50%",
            maxWidth: "80vw",
            height: "100vh",
            ml: "auto",
            borderTopLeftRadius: "15px",
            borderBottomLeftRadius: "15px",
          },
        }}
      >
        <DialogContent>
        <LoanActivity  />
        </DialogContent>
      </Dialog>
    
   
    </div>
    
</div>

                    <div style={{display:'flex',flexDirection:'row', justifyContent:'space-between', boxShadow:'0px 0px 3px 0px #00000026',borderRadius:'10px', border: '1px solid #DBDBDB'}}>
               
                            <div  style={{ display: "flex", flexDirection: "row",justifyContent:'space-between',alignItems:'center', width:'100%', padding: '12px 0px 14px 12px'}}>
                              <img
                                src={selfie || USER}
                                style={{
                                  height: "80px",
                                  width: "80px",
                                  borderRadius: "50%",
                                  boxShadow: '0 4px 8px 0 rgba(217, 106, 21, 0.2), 0 6px 20px 0 rgba(234, 177, 97, 0.19)'
                                }} alt="user profile"
                              />
                              <div style={{display:'flex',flexDirection:'column', marginLeft:'12px',   flex: 1,}}>
                                <div style={{display:'flex', flexDirection:'row', }}>
                                  <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', width:'100%',}}>
                                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}} >
                                      <p
                                      style={{
                                        margin: "0",
                                        color: "#D32028",
                                        fontWeight: "600",
                                        marginBottom:'5px',
                                        fontSize: "18px",cursor:'pointer'
                                      }}  onClick={() => handleUser()}
                                    >
                                      {loanDetails.firstName
                                        ? loanDetails.firstName + " " + loanDetails.lastName
                                        : <span style={{ color: '#98A2B3', fontStyle: 'italic', fontWeight: 400, fontSize: '16px' }}>Loading...</span>}
                                    </p>
                                    <Tooltip title="View Customer Dashboard" arrow>     
                                      <VisibilityOutlinedIcon label={"Preview Customer Dashboard"}
                                          style={{ marginLeft: "16px", cursor: "pointer", color: "#59761A", fontSize:'20px', marginTop:'8px' }}
                                      onClick={() => {
                                            openCustomerDashboard(loanDetails?.mobile);
                                      }}/>
                                    </Tooltip>
                                  </div>
                                    <Connect handleMobileDetails={handleMobileDetails} loanDetails={loanDetails}/>
                                  </div>
                                </div>
                                <DetailsCard loanDetails={loanDetails}/>
                              </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "20px",
                      }}
                    > <div style={{
                      display: "flex",
                      alignItems: "center",
                       }}> 
                  <Modal isOpen={agreementModal}  size="xl" style={{height:'100%'}}>
                          <ModalHeader toggle={toggleAgreement}>Agreement</ModalHeader>
                          <ModalBody >
                          <iframe title="Agreement"
                              src={agreementUrl}
                              width="100%"
                              height="1000vh"
                              style={{ border: 'none' }}
                            ></iframe>
                          </ModalBody>
                          
                        </Modal>

                        <Modal isOpen={sanctionLetterModal}  size="xl" style={{height:'100%'}}>
                          <ModalHeader toggle={toggleSanctionLetter}>Sanction Letter</ModalHeader>
                          <ModalBody >
                            
                          <iframe title="Sanction Letter"
                              src={sanctionUrl }
                              width="100%"
                              height="1000vh"
                              style={{ border: 'none' }}
                            ></iframe>
                          </ModalBody>
                          
                        </Modal>

                         <Modal isOpen={demandLetterModal}  size="xl" style={{height:'100%'}}>
                          <ModalHeader toggle={handleFetchAndSend}>Demand Letter</ModalHeader>
                          <ModalBody >
                            
                          <iframe title="Demand Letter"
                              src={demandletter}
                              width="100%"
                              height="1000vh"
                              style={{ border: 'none' }}
                            ></iframe>
                          </ModalBody>
                          
                        </Modal>

                         <Modal isOpen={legalLetterModal}  size="xl" style={{height:'100%'}}>
                          <ModalHeader toggle={closeLegalLetterModal } >Legal Letter</ModalHeader>
                          <ModalBody >
                            
                          <iframe title="Legal Letter"
                              src={legalletterGenarate}
                              width="100%"
                              height="1000vh"
                              style={{ border: 'none' }}
                             
                            ></iframe>
                          </ModalBody>
                          
                        </Modal>
                      
                      <Modal isOpen={isEmiModalOpen} toggle={toggleEmiStatus}>
                                <ModalHeader toggle={toggleEmiStatus} style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'left' }}>
                                  <h5 className="w-100 text-left">Update Loan Status</h5></ModalHeader>
                                  
                                  <div style={{paddingLeft:'30px'}}>
                                  { loanstate?.status === 7 ?  "Do you want to move the status to Active?" : "Do you want to move the status to Pause?"}

                                    <div style={{marginTop:'20px'}}>
                                      
                                        <label for="remarks">Notes:</label>
                                        <input type="text" id="remarks" name="remarks" placeholder=" Notes" onChange={(e)=>{ 
                                        setActivityNotes(e.target.value);}
                                        }  />

                                     </div>

                                  </div>
                               
                            <div style={{ display: 'flex', justifyContent:'center', marginTop:'20px'}}>
                              <div style={{marginRight:'20px'}}>
                              <Button onClick={() => {handlePausedClick(statusPausedValue);}
                              } 
                              style={{ width: '100%', borderRadius: '1em', backgroundColor: '#D32028', color: 'white', marginBottom: '1em' }}
                              disabled={!activityNotes?.trim()} >
                               Confirm
                              </Button>
                              </div>
                              <div  style={{marginLeft:'20px'}}>
                              <Button onClick={toggleEmiStatus} style={{ width: '100%', borderRadius: '1em', backgroundColor: '#D32028', color: 'white', marginBottom: '1em' }}>
                                Cancel
                              </Button>
                              </div>
                            </div>
                         
                                </Modal>
                          
                      </div>

                      <div   style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "10px",
                               }}>   
                     
                               <Modal
                                  isOpen={openBankStatementDialog}
                                  
                                  centered
                                >
                                  <ModalHeader style={{ fontFamily: "Outfit" }} toggle={() =>{
                                    setOpenBankStatementDialog(false)
                                    setError("")
                                    setFromDate(null)
                                    setToDate(null)
                                    }}>
                                    Download Bank Statement
                                  </ModalHeader>

                                  <ModalBody
                                    style={{
                                      minHeight: "150px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "10px"
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: "12px",
                                        width: "100%",
                                        justifyContent: "center"
                                      }}
                                    >
                                    
                                      <Datetime
                                        closeOnSelect={false}
                                        id="fromDate"
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        onChange={handleFromDate}
                                        locale="en-gb"
                                        inputProps={{
                                          placeholder: "From Date",
                                          style: { fontFamily: "Outfit", fontSize: "14px" }
                                        }}
                                        isValidDate={(current) => current.isSameOrAfter(moment(consentDate, "YYYY-MM-DD"), "day")}
                                      />
                                      <Datetime
                                        closeOnSelect={false}
                                        id="toDate"
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        onChange={handleToDate}
                                        locale="en-gb"
                                        inputProps={{
                                          placeholder: "To Date",
                                          style: { fontFamily: "Outfit", fontSize: "14px" }
                                        }}
                                        isValidDate={(current) => current.isSameOrBefore(yesterday)}
                                      />
                                      
                                    </div>

                                    {error && (
                                      <div style={{ color: "red", fontSize: "14px", fontFamily: "Outfit" }}>
                                        {error}
                                      </div>
                                    )}
                                  </ModalBody>

                                  <ModalFooter style={{ justifyContent: "center" }}>
                                  

                                    <MuiButton
                                      variant="contained"
                                      disabled={disableDownload || statementLoading}
                                      sx={{
                                        backgroundColor: disableDownload ? "#ccc" : "#d32028",
                                        fontFamily: "Outfit",
                                        textTransform: "none",
                                        color: "#fff",
                                        "&:hover": {
                                          backgroundColor: disableDownload ? "#ccc" : "#b81c22"
                                        }
                                      }}
                                      onClick={handleDownloadBankStatement}
                                    >
                                    {statementLoading? 'Downloading...' : 'Download'}
                                    </MuiButton>
                                  </ModalFooter>
                                </Modal>


 {/* request-refund option,Modal */}
<Modal isOpen={refundModalOpen} toggle={() => setRefundModalOpen(false)}>
  <ModalHeader toggle={() => setRefundModalOpen(false)} style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'left' }}>
    <h5 className="w-100 text-left">Request Refund</h5>
  </ModalHeader>
  <ModalBody>
    <div style={{ padding: '0 20px' }}>
      <div >
        <label htmlFor="refundReason">Reason for cancellation</label>
        <textarea
          id="refundReason"
          rows="2"
          style={{ width: '100%', padding: '10px', marginTop: '1px', borderRadius: '6px', border: '1px solid #ccc' }}
          placeholder="Enter reason"
          value={refundReason}
          onChange={(e) => setRefundReason(e.target.value)}
        />
      </div>
      {/* course-field */}
      <div style={{ marginTop: '15px' }}>
  <label htmlFor="courseName">Course Name</label>
  <input
    type="text"
    id="courseName"
    style={{ width: '100%', padding: '10px', marginTop: '1px', borderRadius: '6px', border: '1px solid #ccc' }}
    placeholder="Enter course name"
    value={courseName}
    onChange={(e) => setCourseName(e.target.value)}
  />
</div>
{/* email-chipsstyleinputs, */}
      <div style={{ marginBottom: '1px' }}>
  <label htmlFor="institutePOCs">Institute POCs (Emails)</label>
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', border: '1px solid #ccc', borderRadius: '6px', padding: '8px', minHeight: '40px' }}>
    {emails.map((email, index) => (
      <span key={index} style={{ backgroundColor: '#e0e0e0', padding: '4px 8px', borderRadius: '16px', display: 'flex', alignItems: 'center' }}>
        {email}
        <span
          style={{ marginLeft: '8px', cursor: 'pointer', fontWeight: 'bold' }}
          onClick={() => setEmails(emails.filter((email, i) => i !== index))}
        >
          ×
        </span>
      </span>
    ))}
    <input
      type="email"
      style={{ border: 'none', outline: 'none', flex: 1, minWidth: '200px' }}
      placeholder="Type email and press Enter"
      value={currentEmail}
      onChange={(e) => setCurrentEmail(e.target.value)}
      onKeyDown={(e) => {
        if (e.key ==='Enter'&& currentEmail.trim()) {
          setEmails([...emails, currentEmail.trim()]);
          setCurrentEmail('');
          e.preventDefault();
        }
      }}
    />
  </div>
</div>
                  <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
                            <input
                              type="checkbox"
                              id="sendEmailCheckbox"
                              checked={sendEmail}
                              onChange={(e) => setSendEmail(e.target.checked)}
                              style={{ marginRight: '8px', cursor: 'pointer' }}
                            />
                            <label htmlFor="sendEmailCheckbox" style={{ cursor: 'pointer', margin: 0 }}>
                              Send email notification
                            </label>
                          </div>
      
    </div>
  </ModalBody>
  <ModalFooter className="justify-content-center">
    <Button
      color="primary"
      onClick={() => {
        createRefund();
}}
      style={{ backgroundColor: '#D32028' }}
    >
      Submit
    </Button>
  </ModalFooter>

</Modal>
                            
                              <Modal isOpen={openmodal} toggle={toggled}>
                              <ModalHeader toggle={toggled} style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'left' }}>
                                  <h5 className="w-100 text-left">Update Loan Status</h5>
                                </ModalHeader>
                              <ModalBody>
                                {/* Display Current Status */}
                                <div style={{ fontSize: '16px', marginBottom: '15px' }}>
                                  <strong>Current Status: </strong>
                                  {loanstate?.status === 1 ? 'Active' :
                                    loanstate?.status === 2 ? 'Closed' :
                                    loanstate?.status === 3 ? 'Overdue' :
                                    loanstate?.status === 4 ? 'WrittenOff' :
                                    loanstate?.status === 5 ? 'MandateActive' :
                                    loanstate?.status === 6 ? 'Refund' :
                                    loanstate?.status === 7 ? 'Paused' :
                                    loanstate?.status === 8 ? 'Legal' :
                                    loanstate?.status === 9 ? 'Settled' :
                                    loanstate?.status === 10 ? 'OptedOut' :
                                    loanstate?.status === 11 ? 'WrittenOff-Closed' :
                                    loanstate?.status === 12 ? 'Settled-Closed' :
                                    loanstate?.status}
                                  </div>

                                {/* Loan Status Dropdown */}
                                <div>
                                  <label htmlFor="loanStatus">New Loan Status: </label>
                                  <select id="loanStatus" value={selectedStatus} onChange={handleChange} style={{ marginLeft: '10px' }}>
                                    <option value="" disabled>Select Loan Status</option>
                                    {Object.entries(loanStatusOptions).map(([key, value]) => (
                                      <option key={key} value={key} disabled={isStatusDisabled(key)}>
                                        {value}
                                      </option>
                                    ))}
                                  </select>

                                  <div style={{marginTop:'20px'}}>
                                      
                                  <label for="remarks">Notes:</label>
                                        <input type="text" id="remarks" name="remarks" placeholder=" Notes" 
                                         onChange={(e)=>{ 
                                        setActivityNotes(e.target.value);}
                                        }/>

                                   </div>

                                </div>

                                
                              </ModalBody>

                              <ModalFooter className="justify-content-center">
                                        
                                <Button color="primary" onClick={()=>{handleYesClick();}
                                } disabled={loanstate?.status === 2  || loanstate?.status === 6 || !selectedStatus || !activityNotes?.trim() } className="mx-2">
                                  Submit
                                </Button>
                              </ModalFooter>
                            </Modal> 
                               
                              <Modal isOpen={wittenOff} toggle={WrittenOfftoggled}>
                              <ModalHeader toggle={WrittenOfftoggled} style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'left' }}>
                                  <h5 className="w-100 text-left">Update Loan Status</h5>
                                </ModalHeader>
                              <ModalBody>
                                {/* Display Current Status */}
                                <div style={{ fontSize: '16px', marginBottom: '15px' }}>
                                  <strong>Current Status: </strong>
                                  {loanstate?.status === 1 ? 'Active' :
                                    loanstate?.status === 2 ? 'Closed' :
                                    loanstate?.status === 3 ? 'Overdue' :
                                    loanstate?.status === 4 ? 'WrittenOff' :
                                    loanstate?.status === 5 ? 'MandateActive' :
                                    loanstate?.status === 6 ? 'Refund' :
                                    loanstate?.status === 7 ? 'Paused' :
                                    loanstate?.status === 8 ? 'Legal' :
                                    loanstate?.status === 9 ? 'Settled' :
                                    loanstate?.status === 10 ? 'OptedOut' :
                                    loanstate?.status}
                                  </div>
                         <div  style={{display:'flex'}}>
                          <div  style={{marginBottom:'20px'}}>
                         
                          <Grid container spacing={2} marginTop="10px">
                          <Grid item xs={10}>
                            <TextField 
                              label="Total Loan Amount" 
                              variant="outlined"
                              value={writtenLoandata?.loan_amount??'0'}
                              InputLabelProps={{ style: { fontSize: '12px' }, shrink: true }} 
                              sx={{ width: '100%', '& .MuiInputBase-root': { height: '40px' } }} 
                            />
                          </Grid>

                          <Grid item xs={10}>
                            <TextField 
                              label=" Total Disbursed" 
                              variant="outlined" 
                              value={writtenLoandata?.disbursement_amount ?? '0'}
                              InputLabelProps={{ style: { fontSize: '12px' }, shrink: true }} 
                              sx={{ width: '100%', '& .MuiInputBase-root': { height: '40px' } }} 
                            />
                          </Grid>

                          <Grid item xs={10}>
                            <TextField 
                              label="Total outstanding" 
                              variant="outlined" 
                              value={writtenLoandata?.remaining_amount??'0'}
                              InputLabelProps={{ style: { fontSize: '12px' }, shrink: true }} 
                              sx={{ width: '100%', '& .MuiInputBase-root': { height: '40px' } }} 
                            />
                          </Grid>

                          <Grid item xs={10}>
                            <TextField 
                              label="Total principal outstanding" 
                              variant="outlined"
                              value={writtenLoandata?.total_principle_amount??'0'} 
                              InputLabelProps={{ style: { fontSize: '12px' }, shrink: true }} 
                              sx={{ width: '100%', '& .MuiInputBase-root': { height: '40px' } }} 
                            />
                          </Grid>
                       </Grid>
                            
                          </div>

                          <div  style={{marginBottom:'20px'}}>


                          <Grid container spacing={2} marginTop="10px">
                              <Grid item xs={10}>
                                <TextField
                                  label="Principle written off"
                                  variant="outlined"
                                   type="number"
                                  name="principleWrittenOff"
                                  value={formData.principleWrittenOff}
                                  onChange={handleChangeWritterOff}  // Update state on change
                                   onWheel={(e) => e.target.blur()}
                                  InputLabelProps={{ style: { fontSize: "12px" } }}
                                  sx={{ width: "100%", "& .MuiInputBase-root": { height: "40px" } }}
                                />
                              </Grid>

                              <Grid item xs={10}>
                                <TextField
                                  label="Interest written off"
                                  variant="outlined"
                                   type="number"
                                  name="interestWrittenOff"
                                  value={formData.interestWrittenOff}
                                   onWheel={(e) => e.target.blur()}
                                  onChange={handleChangeWritterOff}
                                  InputLabelProps={{ style: { fontSize: "12px" } }}
                                  sx={{ width: "100%", "& .MuiInputBase-root": { height: "40px" } }}
                                />
                              </Grid>

                              <Grid item xs={10}>
                                <TextField
                                  label="Other charges written off"
                                  variant="outlined"
                                   type="number"
                                  name="othercharges"
                                  value={formData.othercharges}
                                  onChange={handleChangeWritterOff}
                                   onWheel={(e) => e.target.blur()}
                                  InputLabelProps={{ style: { fontSize: "12px" } }}
                                  sx={{ width: "100%", "& .MuiInputBase-root": { height: "40px" } }}
                                />
                              </Grid>

                              <Grid item xs={10}>
                                <TextField
                                  label="Legal Charges"
                                  type="number"
                                  variant="outlined"
                                  name="legalCharges"
                                  value={formData.legalCharges}
                                   onWheel={(e) => e.target.blur()}
                                  onChange={handleChangeWritterOff}
                                  InputLabelProps={{ style: { fontSize: "12px" } }}
                                  sx={{ width: "100%", "& .MuiInputBase-root": { height: "40px" } }}
                                />
                              </Grid>
                        </Grid>
                                                
                              </div>
                                </div>

                                {/* Loan Status Dropdown */}



                                 <Grid item xs={10}>
                                  <TextField
                                    label="Writtenoff Date"
                                    type="date"
                                    variant="outlined"
                                    name="writtenoffDate"
                                    value={formData.writtenoffDate}
                                    onChange={handleChangeWritterOff}
                                   error={writtenoffDateError} // true if empty
                                   helperText={writtenoffDateError ? "Writtenoff Date is required" : ""}
                                    InputLabelProps={{
                                      style: { fontSize: '12px' },
                                      shrink: true
                                    }}
                                    sx={{
                                      width: "100%",
                                      "& .MuiInputBase-root": {
                                        height: "40px",
                                        marginBottom: '10px'
                                      }
                                    }}
                                  />
                                </Grid> 
                              

                                <Grid item xs={10}>
                                <TextField
                                 label="Notes"
                                 type="text"
                                variant="outlined"
                                name="remarks"
                               error={remarksError}
                                helperText={remarksError ? "Notes is required" : ""}
                                onChange={(e)=>{ 
                                  setActivityNotes(e.target.value);}}
                                InputLabelProps={{ style: { fontSize: "12px" } }}
                                sx={{ width: "100%", "& .MuiInputBase-root": { height: "40px" } }}></TextField>
                                  </Grid>
                                 

                             
                                 
                                
                              </ModalBody>

                              <ModalFooter className="justify-content-center">
                                        
                                <Button color="primary" onClick={()=>{handleYesClickwrittenOff();}} disabled={loanstate?.status === 2  || loanstate?.status === 6  } className="mx-2">
                                  Submit
                                </Button>
                              </ModalFooter>
                            </Modal> 

                          
                    </div>



                    </div>
                            </div>
                            {popUp && (
        <>
         <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999,
      }}
    ></div>
        <Modal style={{
      left:"0%",
      top:"30%",width:'400px',borderRadius:"10px"}} isOpen={popUp}>
       
          <Form>
            <FormGroup>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:'20px',paddingLeft:'20px'}}>
              <p style={{display:'flex',alignItems:'center'}}><span style={{color:'#D22129',fontFamily:'Inter-Medium',fontSize:'20px',fontWeight:'500'}}>Mobile :</span><span style={{fontFamily:'Inter-Medium',fontSize:'20px',fontWeight:'500',color:'black',marginLeft:'20px'}}>{loanDetails.mobile}</span> </p>
              <p style={{marginRight:'20px',cursor:"pointer",marginBottom:'30px'}}><img onClick={() => setpopUp(!popUp)} src={close} alt="close"/></p>
              </div>
            </FormGroup>
          </Form>
       
        
      </Modal>
        </>
      )}

         <Modal isOpen={MandateModal} toggle={toggleMandateDetails} size="lg">
               <ModalHeader toggle={toggleMandateDetails}>Mandate Details</ModalHeader>
               
               <ModalBody>
                 {/* {loanDetails?.mandateDetails?.type === 'Digio' ? (
                   <DigioMandateFields loanDetails={loanDetails} />
                 ) : (
                   <> */}
                   <Box sx={{ width: '100%', borderRadius: '10px' }}>
                       <Box px={2} py={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         <strong style={{ fontSize: 14, color: '#314158' }}>Applicant Mandate Details</strong>
                         {loanDetails?.coapplicantMandateDetails && loanDetails?.mandatePrimary !== 2 && (
                           <span style={{ fontSize: 11, backgroundColor: '#ECFDF3', color: '#027A48', borderRadius: '999px', padding: '2px 10px', fontWeight: 600, border: '1px solid #A6F4C5' }}>Primary</span>
                         )}
                       </Box>
                       <Divider />
                 
                       <Box px={2} py={2}>
                         <Grid container spacing={2}>
                           <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Applicant Name"
                                disabled
                                value={`${loanDetails.firstName} ${loanDetails.lastName}`}
                                InputProps={{
                                  sx: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    height: 45,
                                    alignItems: 'center', 
                                  },
                                }}
                                InputLabelProps={{
                                sx: {
                                    marginLeft: '8px', 
                                    backgroundColor: '#fff',
                                    padding: '0 4px',
                                  },
                                  shrink: true, 
                                }}
                              />

                           </Grid>
                           <Grid item xs={12} md={6}>
                             <TextField
                               fullWidth
                               label="Type"
                               value={loanDetails?.mandateDetails?.type}
                                disabled
                                InputProps={{
                                      sx: {
                                        fontWeight: 500,
                                        fontSize: 14,
                                        height: 45,
                                      },
                                    }}
                                     InputLabelProps={{
                                  sx: {
                                      marginLeft: '8px', 
                                      backgroundColor: '#fff',
                                      padding: '0 4px',
                                    },
                                    
                                  }}
                              
                             />
                           </Grid>
                           <Grid item xs={12} md={6}>
                             <TextField
                               fullWidth
                               label="Account Number"
                               value={loanDetails?.mandateDetails?.accountNumber}
                                disabled
                                 InputProps={{
                                    sx: {
                                      fontWeight: 500,
                                      fontSize: 14,
                                      height: 45,
                                    },
                                  }}
                                   InputLabelProps={{
                                  sx: {
                                      marginLeft: '8px', 
                                      backgroundColor: '#fff',
                                      padding: '0 4px',
                                    },
                                    
                                  }}
                               
                             />
                           </Grid>
                           <Grid item xs={12} md={6}>
                             <TextField
                               fullWidth
                               label="IFSC"
                                value={loanDetails?.mandateDetails?.ifsc}
                                 disabled
                                InputProps={{
                                  sx: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    height: 45,
                                  },
                                }}
                                 InputLabelProps={{
                                  sx: {
                                      marginLeft: '8px', 
                                      backgroundColor: '#fff',
                                      padding: '0 4px',
                                    },
                                    
                                  }}
                              
                             />
                           </Grid>
                           {loanDetails?.mandateDetails?.type !== "Digio" ? (
                            <>
                             <Grid item xs={12} md={6}>
                                <TextField
                                  fullWidth
                                  label="Customer ID"
                                  value={customerId}
                                  disabled
                                  InputProps={{
                                    sx: {
                                      fontWeight: 500,
                                      fontSize: 14,
                                      height: 45,
                                    },
                                  }}
                                   InputLabelProps={{
                                  sx: {
                                      marginLeft: '8px', 
                                      backgroundColor: '#fff',
                                      padding: '0 4px',
                                    },
                                    
                                  }}
                                  
                                />
                              </Grid>

                          <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Token ID"
                                value={tokenId}
                                disabled
                                InputProps={{
                                  sx: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    height: 45,
                                  },
                                }}
                                 InputLabelProps={{
                                  sx: {
                                      marginLeft: '8px', 
                                      backgroundColor: '#fff',
                                      padding: '0 4px',
                                    },
                                    
                                  }}
                              />
                            </Grid>
                            </>
                           ):
                           <>
                           <Grid item xs={12} md={12}>
                              <TextField
                                fullWidth
                                label="Umrn"
                                value={umrn}
                                disabled
                                InputProps={{
                                  sx: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    height: 45,
                                  },
                                }}
                                 InputLabelProps={{
                                  sx: {
                                      marginLeft: '8px', 
                                      backgroundColor: '#fff',
                                      padding: '0 4px',
                                    },
                                    
                                  }}
                              />
                            </Grid>
                           </>}
                          
                         </Grid>
                       </Box>
                     </Box>
 
                    {loanDetails?.coapplicantMandateDetails && (
                      <Box sx={{ width: '100%', borderRadius: '10px', mt: 2, ...(loanDetails?.mandatePrimary === 2 && { backgroundColor: '#F0FDF4', border: '1px solid #86EFAC' }) }}>
                        <Box px={2} py={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <strong style={{ fontSize: 14, color: '#314158' }}>Co-Applicant Mandate Details</strong>
                          {loanDetails?.mandatePrimary === 2 && (
                            <span style={{ fontSize: 11, backgroundColor: '#ECFDF3', color: '#027A48', borderRadius: '999px', padding: '2px 10px', fontWeight: 600, border: '1px solid #A6F4C5' }}>Primary</span>
                          )}
                        </Box>
                        <Divider />
                        <Box px={2} py={2}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Co-Applicant Name"
                                disabled
                                value={loanDetails.coapplicantMandateDetails.customerName || ''}
                                InputProps={{ sx: { fontWeight: 500, fontSize: 14, height: 45 } }}
                                InputLabelProps={{ sx: { marginLeft: '8px', backgroundColor: '#fff', padding: '0 4px' }, shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Type"
                                disabled
                                value={loanDetails.coapplicantMandateDetails.type || ''}
                                InputProps={{ sx: { fontWeight: 500, fontSize: 14, height: 45 } }}
                                InputLabelProps={{ sx: { marginLeft: '8px', backgroundColor: '#fff', padding: '0 4px' } }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Account Number"
                                disabled
                                value={loanDetails.coapplicantMandateDetails.accountNumber || ''}
                                InputProps={{ sx: { fontWeight: 500, fontSize: 14, height: 45 } }}
                                InputLabelProps={{ sx: { marginLeft: '8px', backgroundColor: '#fff', padding: '0 4px' } }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="IFSC"
                                disabled
                                value={loanDetails.coapplicantMandateDetails.ifsc || ''}
                                InputProps={{ sx: { fontWeight: 500, fontSize: 14, height: 45 } }}
                                InputLabelProps={{ sx: { marginLeft: '8px', backgroundColor: '#fff', padding: '0 4px' } }}
                              />
                            </Grid>
                            {loanDetails.coapplicantMandateDetails.type !== "Digio" ? (
                              <>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    fullWidth
                                    label="Customer ID"
                                    disabled
                                    value={loanDetails.coapplicantMandateDetails.customerId || ''}
                                    InputProps={{ sx: { fontWeight: 500, fontSize: 14, height: 45 } }}
                                    InputLabelProps={{ sx: { marginLeft: '8px', backgroundColor: '#fff', padding: '0 4px' } }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    fullWidth
                                    label="Token ID"
                                    disabled
                                    value={loanDetails.coapplicantMandateDetails.tokenId || ''}
                                    InputProps={{ sx: { fontWeight: 500, fontSize: 14, height: 45 } }}
                                    InputLabelProps={{ sx: { marginLeft: '8px', backgroundColor: '#fff', padding: '0 4px' } }}
                                  />
                                </Grid>
                              </>
                            ) : (
                              <Grid item xs={12} md={12}>
                                <TextField
                                  fullWidth
                                  label="Umrn"
                                  disabled
                                  value={loanDetails.coapplicantMandateDetails.digioUmrn || ''}
                                  InputProps={{ sx: { fontWeight: 500, fontSize: 14, height: 45 } }}
                                  InputLabelProps={{ sx: { marginLeft: '8px', backgroundColor: '#fff', padding: '0 4px' } }}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      </Box>
                    )}

               </ModalBody>
             </Modal>


        <Modal isOpen={legalLetterModalOpen} toggle={closeLegalLetterModal} size="m">
            <ModalHeader toggle={closeLegalLetterModal}>
              Enter Legal Letter Details
            </ModalHeader>
             <ModalBody>
                <Grid container spacing={2}  style={{marginTop:'10px'}}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Mandate Raised Date"
                      type="date"
                      name="mandateRaisedDate"
                      value={legalLetter.mandateRaisedDate}
                      onChange={handleLegalLetterInputChange}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" // adjust as needed
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                    error={!!legalLetterErrors.mandateRaisedDate}
                    helperText={legalLetterErrors.mandateRaisedDate}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Mandate Failed Date"
                      type="date"
                      name="mandateFailedDate"
                      value={legalLetter.mandateFailedDate}
                      onChange={handleLegalLetterInputChange}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" // adjust as needed
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                    error={!!legalLetterErrors.mandateFailedDate}
                    helperText={legalLetterErrors.mandateFailedDate}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Soft Notice Date"
                      type="date"
                      name="softNoticeDate"
                      value={legalLetter.softNoticeDate}
                      onChange={handleLegalLetterInputChange}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" // adjust as needed
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                    error={!!legalLetterErrors.softNoticeDate}
                    helperText={legalLetterErrors.softNoticeDate}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Overdue EMI Amount"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      name="overdueEmiAmount" 
                      value={legalLetter.overdueEmiAmount}
                      onChange={handleLegalLetterInputChange}
                      fullWidth
                      sx={{
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" 
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                      error={!!legalLetterErrors.overdueEmiAmount}
                      helperText={legalLetterErrors.overdueEmiAmount}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Penalty + Bounce Charges"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      name="penaltyAndBounceCharges"
                      value={legalLetter.penaltyAndBounceCharges}
                      onChange={handleLegalLetterInputChange}
                      fullWidth
                      sx={{
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" // adjust as needed
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                      error={!!legalLetterErrors.penaltyAndBounceCharges}
                      helperText={legalLetterErrors.penaltyAndBounceCharges}
                    />
                    
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Total Outstanding Amount (incl. future)"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      name="totalOutstanding"
                      value={legalLetter.totalOutstanding}
                      onChange={handleLegalLetterInputChange}
                      fullWidth
                      sx={{
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" // adjust as needed
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                      error={!!legalLetterErrors.totalOutstanding}
                        helperText={legalLetterErrors.totalOutstanding}
                    />
                  </Grid>


                  

                <Grid item xs={12} sm={6}>
                <TextField
                  label="Mandate Failed Count"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  name="mandateFailedCount"
                  value={legalLetter.mandateFailedCount}
                  onChange={handleLegalLetterInputChange}
                  fullWidth
                  error={!!legalLetterErrors.mandateFailedCount}
                  helperText={legalLetterErrors.mandateFailedCount}
                  sx={{
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" // adjust as needed
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                />
              </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="Mandate Failed Reason"
                      name="mandateFailedReason"
                      value={legalLetter.mandateFailedReason}
                      onChange={handleLegalLetterInputChange}
                      fullWidth
                      multiline
                      sx={{
                      '& .MuiInputBase-root': {
                        fontSize: '14px',
                        height: "45px" // adjust as needed
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                    
                        error={!!legalLetterErrors.mandateFailedReason}
                        helperText={legalLetterErrors.mandateFailedReason}
                    />
                  </Grid>
                </Grid>
              </ModalBody>

            <ModalFooter>
              <Button onClick={closeLegalLetterModal} style={{ backgroundColor: '#d32028', borderColor: '#d32028' }}>
                Cancel
              </Button>
              <Button onClick={submitLegalLetter} style={{ backgroundColor: '#d32028', borderColor: '#d32028' }}>
                Submit
              </Button> 
            </ModalFooter>
         </Modal>
                </div>

                   <Modal isOpen={modal} toggle={toggleMandate} backdrop="static">
                      <ModalHeader toggle={toggleMandate}>Mandate Presentation</ModalHeader>
                      <ModalBody>
                          {presentMandateLoading ? (
                              <div>
                                  <p style={{ fontFamily: 'Inter-Medium', fontWeight: 'bold', color: '#d32808', textAlign: 'center' }}>Wait.. While Presenting</p>
                                  <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%', backgroundColor: 'white' }}>
                                      <CircularProgress />
                                  </Box>
                              </div>
                          ) : otpSent && !otpVerified ? (
                              <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                  <p style={{ fontFamily: 'Inter-Medium', fontSize: '14px' }}>
                                      An OTP has been sent to mobile number <strong>{maskMobileNumber(otpMobile)}</strong>
                                  </p>
                                  <TextField
                                      label="Enter 6-digit OTP"
                                      variant="outlined"
                                      value={otp}
                                      onChange={(e) => {
                                          const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                                          setOtp(value);
                                      }}
                                      inputProps={{ maxLength: 6, style: { textAlign: 'center', fontSize: '20px', letterSpacing: '8px' } }}
                                      style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}
                                      disabled={otpLoading}
                                  />
                                  <p style={{ fontFamily: 'Inter-Medium', fontSize: '14px', color: '#667085', textAlign: 'center', marginTop: '10px' }}>
                                      On clicking verify and submit, mandate will be raised
                                  </p>
                              </div>
                          ) : !otpSent ? (
                              <div>
                                  {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', backgroundColor: 'rgba(252, 240, 241, 1)', flexDirection: 'column', borderRadius: "10px", padding: '20px' }}>
                                     {loanDetails?.mandateDetails?.type !== "Digio" ? <><p>Max Amount Allowed : <span style={{ fontWeight: 'bold' }}>{maxAmount !== null ? formatNumberWithCommas(maxAmount) : 'N/A'} </span></p></>:null} 
                                     <p>Amount Raising For : <span style={{ fontWeight: 'bold' }}>{remainingAmountToBePaid !== null ? formatNumberWithCommas(remainingAmountToBePaid) : 'N/A'} </span></p>
                                     <p style={{ fontFamily: 'Inter-Medium', fontSize: '14px', color: '#667085', marginTop: '10px' }}>
                                         On clicking submit, OTP will be sent to mobile number <strong>{maskMobileNumber("7675997802")}</strong>
                                     </p>
                                      <button 
                                          style={{ paddingLeft: '10px', fontFamily: 'Inter-medium', color: 'white', backgroundColor: '#D32028', paddingRight: '10px', borderRadius: '10px', marginBottom: '10px', marginTop: '10px' }} 
                                          onClick={handleSubmitMandate}
                                          disabled={otpLoading}
                                      >
                                          {otpLoading ? 'Sending...' : 'Submit'}
                                      </button>
                                  </div>
                              </div>
                          ) : null}

                      </ModalBody>
                      <ModalFooter style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                          {otpSent && !otpVerified && (
                              <Button 
                                  color="primary" 
                                  style={{backgroundColor:"#D22129",border:'none'}} 
                                  onClick={handleSubmitMandate} 
                                  disabled={otpLoading || otp.length !== 6}
                              >
                                  {otpLoading ? 'Verifying...' : 'Verify and Submit'}
                              </Button>
                          )}
                      </ModalFooter>
                    </Modal>

                <Modal isOpen={isModalOpen} toggle={toggleModal} backdrop="static">
        <ModalHeader toggle={toggleModal}>Payment Link</ModalHeader>
        <ModalBody >
        <p style={{lineHeight:'1em',fontFamily:'Inter-Medium',fontSize:'14px'}}>LoanId</p>
        <InputGroup>
            <Input value={LoanId} disabled/>
          </InputGroup>
          
        <p style={{lineHeight:'1em',fontFamily:'Inter-Medium',fontSize:'14px',marginTop:'10px'}}>Amount</p>
        <InputGroup>
            <Input value={amount}/>
          </InputGroup>
          
          <p style={{lineHeight:'1em',fontFamily:'Inter-Medium',fontSize:'14px',marginTop:'10px'}}>Remarks</p>
        <InputGroup>
            <Input onChange={(e)=>setRemarks(e.target.value)}/>
          </InputGroup>
         
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <FormGroup check style={{marginTop:'10px'}}>
            <Label check >
               SMS
            </Label>
            <Input type="checkbox" style={{marginTop:'12px'}}/>{' '}
          </FormGroup>
          <FormGroup check style={{marginTop:'10px'}}>
            <Label check  >
               WhatsApp
            </Label>
            <Input type="checkbox" style={{marginTop:'12px'}}/>{' '}
          </FormGroup>
          <FormGroup check style={{marginTop:'10px'}}>
            <Label check  >
               Email
            </Label>
            <Input type="checkbox" style={{marginTop:'12px'}}/>{' '}
          </FormGroup>
          </div>
          
          
        </ModalBody>
        <Button style={{backgroundColor:'#D32028',border:'none',width:'25%',display:'flex',justifyContent:'center',marginLeft:'35%',marginBottom:'15px',marginTop:'10px',whiteSpace:'nowrap'}} onClick={generatelink}>
            Generate Link
          </Button>
        </Modal>
        <Modal isOpen={showPaymentLinkModal} toggle={togglePaymentLinkModal} backdrop="static" style={{top:'10%'}}>
        <ModalHeader toggle={togglePaymentLinkModal}>Payment Link</ModalHeader>
        <ModalBody>
          {/* <p style={{fontFamily:'Inter-Medium'}}> {paymentLink}{" "}
          <span onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
              <img src={copy} style={{height:'20px',width:'20px',marginLeft:'50px'}} title='copy to clipboard' alt=""/>
            </span>
          </p> */}
          <p style={{fontFamily:'Inter-Medium', textAlign:'center'}}>Link generated successfully and customer notified.</p>
        </ModalBody>
      </Modal>
               <div style={{borderRadius:'10px',borderStyle:'solid', boxShadow:'0px 0px 3px 0px #00000026',borderColor:'#DBDBDB',borderWidth:'1px',marginTop:'2em'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between', alignItems:'center',padding:'12px 12px'}}>
                            <div style={{display:'flex',flexDirection:'row', alignItems:'center', lineHeight:'12px'}}>
                                <div style={{  width: "150px",cursor:'pointer' }}  onClick={() => navigate('/Emis', { state: { loanDetails } })}>
                                  <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between', alignItems:'center'}}>
                                     <p style={{ margin: 0, fontSize: "14px", fontWeight:'bold',  color:'#314158', }}>
                                      EMI Progress
                                    </p>
                                    <span style={{  fontSize: "12px", color:'#667085', fontWeight:'600' }}>
                                        {Math.round((countStatus2 / totalCount) * 100)}%
                                    </span>      
                                  </div>
                                 

                                  <div style={{
                                    marginTop: "6px",
                                    height: "10px",
                                    width: "100%",
                                    backgroundColor: "#E5E5E5",
                                    borderRadius: "8px",
                                    overflow: "hidden"
                                  }}>
                                    <div
                                      style={{
                                        height: "100%",
                                        width: `${Math.round((countStatus2 / totalCount) * 100)}%`,
                                        backgroundColor: getProgressColor(Math.round((countStatus2 / totalCount) * 100)),
                                        transition: "width 0.4s ease"
                                      }}
                                    />
                                  </div>

                                  <p style={{ marginTop: "6px", fontSize: "12px", color:'#90a1b9',marginBottom:'0px' }}>
                                    {countStatus2} of {totalCount} EMIs paid 
                                  </p>
                                  </div>

                                
                                </div> 
                                  <Amounts loanDetails={loanDetails} preCloseAmount={preCloseAmount} foreCloseAmount={foreCloseAmount} totalEmiAmount={totalEmiAmount} isPreClosure={preClosure} principlePaid={principlePaid} interestPaid={interestPaid} preClosecharges={preClosecharges}/>
                          
                              <div
                            // onMouseEnter={() =>{if(selectedItems?.length > 0) setOpenCollections(true)}}
                            // onMouseLeave={() =>setOpenCollections(false)}
                            style={{ display: "inline-block" }}
                          >
                            <MuiButton 
                              ref={collectRef}
                              id="collcections"
                              variant="outlined"
                              color='secondary'
                              onClick={() => setOpenCollections((prev) => !prev)}
                              // disabled={selectedItems?.length < 1}
                              sx={{
                                color: '#416CC7',
                                textTransform: "none",
                                borderColor:'#AEBBD7'
                              }}
                              startIcon={  <PaymentsOutlinedIcon/>}
                            >
                              Collect
                            </MuiButton>

                            <Popper
                              sx={{ zIndex: 1 }}
                              open={openCollections}
                              anchorEl={collectRef.current}
                              placement="bottom-start"
                              transition
                            >
                              {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                  <Paper>
                                    <ClickAwayListener onClickAway={() => {}}>
                                      <MenuList autoFocusItem>
                                        <MenuItem disabled={selectedItems?.length < 1 && !preClosure}>
                                          <PaymentLink handleCollectClose={handleCollectClose} selectedItems={selectedItems} selectedEmiStatuses={selectedEmiStatuses} totalEmiAmount={totalEmiAmount} overdueCharges={overdueCharges} chequeBounceCharges={chequeBounceCharges} loanDetails={loanDetails} interest={interest} isPreClosure={preClosure} discountedBounce={discountedBounce} discountedPenalty={discountedPenalty} paidBounce={paidBounce} paidPenalty={paidPenalty} paidPrinciple={paidPrinciple} paidInterest={paidInterest} principle={principle} foreCloseAmount={foreCloseAmount} futureInterest={futureInterest} style={{marginRight:'10px'}}/>
                                        </MenuItem>
                                        <MenuItem disabled={selectedItems?.length < 1 && !preClosure}>
                                          <ManualPayment  handleCollectClose={handleCollectClose} totalEmiAmount={totalEmiAmount} selectedItems={selectedItems} overdueCharges={overdueCharges} chequeBounceCharges={chequeBounceCharges} loanDetails={loanDetails} interest={interest} userId={loanDetails?.userId} remainingAmount={remainingAmount} legalCharges={legalCharges} isPreClosure={preClosure} discountedBounce={discountedBounce} discountedPenalty={discountedPenalty} principleAmount={principleAmount} paidBounce={paidBounce} paidPenalty={paidPenalty} paidPrinciple={paidPrinciple} paidInterest={paidInterest} principle={principle} foreCloseAmount={foreCloseAmount}
                                  loanstate={loanstate}
                                  activityNotes={activityNotes}
                                  setActivityNotes={setActivityNotes}
                                  remarksError={remarksError}
                                  setRemarksError={setRemarksError}/>
                                        </MenuItem>
                                        <MenuItem disabled={selectedItems?.length < 1 && !preClosure}>
                                          <p  style={{  fontSize: '14px',color:'#314158', lineHeight:1, fontWeight:'bold' }} onClick={toggleMandate}>Present Mandate</p>
                                        </MenuItem>
                                      </MenuList>
                                    </ClickAwayListener>
                                  </Paper>
                                </Grow>
                              )}
                            </Popper>
                          </div>
                        </div>
                        <div style={{paddingBottom:'12px', }}>
                            <ul style={{ border: '1px solid #e2e8f0',listStyle:'none',display:'flex',flexDirection: 'row',justifyContent:'space-between',backgroundColor:'#F9FAFB', paddingTop:'12px', paddingBottom:'12px', paddingLeft:'12px'}}>
                                <li style={{width:'0.5em'}}></li>
                                <li style={{width:'1em',fontSize:'12px',lineHeight:'1.4em', fontWeight:'bold',  color:'#314158',}}>EMI No.</li>
                                <li style={{textAlign:'center' ,fontSize:'12px',width:'6em',lineHeight:'1.4em',fontWeight:'bold' ,  color:'#314158',}}>Due date</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold' , color:'#314158',}}>EMI</li>
                                <li style={{width:'4em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Principal</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Interest</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Bounce Charges</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Penalty</li>
                                <li style={{fontSize:'12px',width:'6em',lineHeight:'1.4em',fontWeight:'bold',textAlign:'center', color:'#314158',}}>Paid date</li>
                                <li style={{width:'3em',textAlign:'center',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Dpds</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Paid Amount</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Paid Principal</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Paid Interest</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Paid Bounces</li>
                                <li style={{width:'3em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Paid Penalty</li>
                                <li style={{width:'5em',lineHeight:'1.4em',fontSize:'12px',fontWeight:'bold', color:'#314158',}}>Status</li>
                                <li style={{ width: '5em', lineHeight: '1.4em', fontSize: '12px', fontWeight: 'bold', color: '#314158', }}>Payment Mode</li>
                                 {/* <li style={{ width: '6em', lineHeight: '1.4em', fontSize: '12px', fontWeight: 'bold', color: '#314158', }}>Transaction ID</li> */}
                                {/* <li style={{width:'7em',textAlign:'center',lineHeight:'1.4em',fontSize:'1vw',fontWeight:'bold'}}>Actions</li> */}
                            </ul>
                            {emiHistoryData?.map((item,idx)=>{
                                const dueDate = item?.dueDate;
                                const emiRepaidDate = 
                                item?.emiRepaidDate && item?.emiRepaidDate !== "Invalid date" 
                                  ? item?.emiRepaidDate 
                                  : item?.emiRepaidDate === "Invalid date"
                                    ? new Date().toLocaleDateString("en-GB")
                                    : '-';
        
                                // Convert strings to Date objects
                                const dueDateObj = new Date(dueDate.split('/').reverse().join('-'));
                                const emiRepaidDateObj = new Date(emiRepaidDate.split('/').reverse().join('-'));
        
                                // Calculate the difference in time (in milliseconds)
                                const differenceInTime = emiRepaidDateObj - dueDateObj;
        
                                // Convert milliseconds to days
                                const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);
                                const result = differenceInDays > 0 ? differenceInDays: '-';
                                return(
                            <ul style={{listStyle:'none',display:'flex',flexDirection: 'row',justifyContent:'space-between', paddingLeft:'12px'}}>
                               <li style={{width:'0.5em', marginTop:'-8px'}}>
                                  <input 
                                    id={idx} 
                                    disabled={item?.status === 2 || item?.status === 4 || item?.status === 7|| item?.status === 9|| item?.status === 10} 
                                    type="checkbox" 
                                    onClick={() => handleCheckboxClick(emiHistoryData, idx)}  
                                  />
                                </li>
                                <li style={{width:'1em', lineHeight:'1.4em', fontSize:'14px'}}>{idx + 1}</li>
                                <li style={{width:'6em', lineHeight:'1.4em', fontSize:'14px', color:'#667085', fontWeight:'500'}}>
                                  {item.dueDate ? item.dueDate.substr(0,10) : "--"}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px', fontWeight:'bold', color:'#314158',}}>
                                  {formatNumberWithCommas(item.emiAmount !== null && item.emiAmount !== undefined ? item.emiAmount : "--")}
                                </li>
                                <li style={{width:'4em', lineHeight:'1.4em', fontSize:'14px', color:'#667085',  fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.principleAmount !== null && item.principleAmount !== undefined ? item.principleAmount : "--")}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px', color:'#667085', fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.interestAmount !== null && item.interestAmount !== undefined ? item.interestAmount : "--")}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px',color: '#fb2c36', fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.bounceCharges !== null && item.bounceCharges !== undefined ? item.bounceCharges : "--")}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px',color:'#fb2c36', fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.overdueCharges !== null && item.overdueCharges !== undefined ? item.overdueCharges : "--")}
                                </li>
                                <li style={{width:'6em', lineHeight:'1.4em', fontSize:'14px'}}>
                                  {item.emiRepaidDate ? item.emiRepaidDate === "Invalid date"?"--":item.emiRepaidDate.substr(0,10) : "--"}
                                </li>
                                <li style={{ width: '3em', lineHeight: '1.4em', fontSize: '14px', color:'#fb2c36' }}> {(result)}</li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px',color: item?.repaidEmiAmount > 0 ? '#009966': '#667085',}}>
                                  {formatNumberWithCommas(item.repaidEmiAmount !== null && item.repaidEmiAmount !== undefined ? item.repaidEmiAmount : "--")}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px', color:'#667085',  fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.paidPrinciple !== null && item.paidPrinciple !== undefined ? item.paidPrinciple : "--")}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px', color:'#667085',  fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.paidInterest !== null && item.paidInterest !== undefined ? item.paidInterest : "--")}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px' ,color:'#667085',  fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.paidBounceCharges !== null && item.paidBounceCharges !== undefined ? item.paidBounceCharges : "--")}
                                </li>
                                <li style={{width:'3em', lineHeight:'1.4em', fontSize:'14px',color:'#667085',  fontWeight:'500'}}>
                                  {formatNumberWithCommas(item.paidOverdue !== null && item.paidOverdue !== undefined ? item.paidOverdue : "--")}
                                </li>

                                <li style={{width:'5em',lineHeight:'1.4em',fontSize:'14px'}}>
                                {item.status?
                            item.status === 1?<span style={{backgroundColor:'#EFE4FF',color:'#6E24E7', borderRadius:'8px',padding:'3px 8px 3px 8px',fontSize:'12px', fontWeight:'bold',  border:'2px solid #d5c0f7ff'}}><img  src={initiateddot} alt=""/>Unpaid</span>
                            :item.status===3?<span style={{backgroundColor:'#FFF6E8',color:'#F8A31F', borderRadius:'8px',padding:'3px',fontSize:'12px',whiteSpace:'nowrap'}}><img  src={pendingdot} alt=""/>PartlyPd.</span>
                            :item.status===2?<span style={{backgroundColor:'#ECFDF3',color:'#12B76A',borderRadius:'8px',padding:'3px 8px 3px 8px',fontSize:'12px', fontWeight:'bold',   border:'1px solid #d0fae5',}}><img  src={activedot} alt=""/>{" "}Paid</span>
                            :item.status===4?<span style={{backgroundColor:'#8ab7ff',color:'black',borderRadius:'8px',padding:'0px 5px 0px 5px',fontSize:'12px',whiteSpace:'nowrap'}}>OvdPd.</span>
                            :item.status===5?<span style={{backgroundColor:'#FEEAEB',color:'#D22129',borderRadius:'8px',padding:'3px 8px 3px 8px',fontSize:'12px', fontWeight:'bold',  border:'2px solid #ffe2e2',}}><img  src={closeddot} alt=""/>{" "}Ovd</span>
                            :item.status===6?<span style={{backgroundColor:'#FFF6E8',color:'#F8A31F', borderRadius:'8px',padding:'3px',fontSize:'12px'}}><img  src={pendingdot} alt=""/>Paused</span>
                            :item.status===7?<span style={{backgroundColor:'#EDC7E2',color:'black', borderRadius:'8px',padding:'3px',fontSize:'12px',whiteSpace:'nowrap'}}><img  src={pendingdot} alt=""/>MIP</span>
                            :item.status===9?<span style={{backgroundColor:'#ECFDF3',color:'#12B76A', borderRadius:'15px',padding:'5px',fontFamily:'Inter',fontSize:'12px',whiteSpace:'nowrap'}}><img  src={activedot} alt=""/>PreCls</span>
                            :item.status===10?<span style={{backgroundColor:'#424242',color:'#E0FFFF', borderRadius:'15px',padding:'5px',fontFamily:'Inter',fontSize:'12px'}}>Refund</span>
                             :item.status===12?<span style={{backgroundColor:'#ebeebe',color:'black', borderRadius:'8px',padding:'3px',fontSize:'12px',whiteSpace:'nowrap'}}><img  src={pendingdot} alt=""/>WrtOff</span>
                             :item.status===11?<span style={{backgroundColor:'#c2f2f3',color:'black', borderRadius:'8px',padding:'3px',fontSize:'12px',whiteSpace:'nowrap'}}><img  src={pendingdot} alt=""/>Settled</span>
                             :item.status===13?<span style={{backgroundColor:'#c2f2f3',color:'black', borderRadius:'8px',padding:'3px',fontSize:'12px',whiteSpace:'nowrap'}}><img  src={pendingdot} alt=""/>OptOut</span>
                            :item.status
                            :'-'}
                                  </li>
                                    <li style={{ width: '5em', lineHeight: '1.4em', fontSize: '12px', color: '#030b1eba', fontWeight: '500' }}>
                                      {item.paymentModeLabel ? (() => {
                                        const modeMap = {
                                          'Mandate': { label: 'EM', color: '#12B76A', title: 'E Mandate' },
                                          'UPI': { label: 'U', color: '#F8A31F', title: 'UPI' },
                                          'ManualPayment': { label: 'M', color: '#c2c210', title: 'Manual' },
                                          'DigioMandate': { label: 'D', color: '#EDC7E2', title: 'Digio Mandate' },
                                          'CustomerPortal': { label: 'CP', color: '#16a1f2', title: 'Customer Portal' },
                                          'CashfreeMandate': { label: 'CM', color: '#e1bfdd', title: 'Cashfree Mandate' },
                                          'CashfreeBbps': { label: 'CB', color: '#e1bfdd', title: 'Cashfree BBPS' },
                                          'DigioEMandate': { label: 'DM', color: '#F7EFED', title: 'Digio E-Mandate' },
                                        };
                                        const mode = modeMap[item.paymentModeLabel] || {
                                          label: item.paymentModeLabel?.slice(0, 2).toUpperCase(),
                                          color: '#cccccc',
                                          title: item.paymentModeLabel
                                        };
                                        return (
                                          <div
                                            title={item.transactionId ? `${mode.title} | TxnID: ${item.transactionId}` : mode.title}
                                            style={{
                                              fontSize: '12px',
                                              backgroundColor: mode.color,
                                              borderStyle: 'solid',
                                              borderRadius: '50%',
                                              border: 'none',
                                              height: '25px',
                                              width: '25px',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              textAlign: 'center',
                                              fontWeight: 'bold',
                                              padding: '5px',
                                              cursor: 'pointer',
                                              borderStyle: 'solid'
                                            }}
                                          >
                                            {mode.label}
                                          </div>
                                        );
                                      })() : '-'}
                                    </li>
                                    {/* <li style={{ width: '6em', lineHeight: '1.4em', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                                      {item.transactionId ?? '-'}
                                    </li> */}

                            </ul>
                            )
                            }
                            )}
                         
                        </div>
                        </div>
                        <div style={{borderStyle:'solid',borderWidth:'1px',marginTop:'30px',borderRadius:'10px',borderColor:'#DBDBDB',boxShadow:'0px 0px 3px 0px #00000026'}}>
                    <div style={{display:'flex',justifyContent:'space-between',paddingRight:'20px'}}>
                    <div style={{display:'flex',marginLeft:'10px',alignItems:'center',marginTop:'10px'}}>
                   <p style={{display:'flex',alignItems:'center',marginTop:'5px',paddingLeft:'10px'}}>
                    <div  style={{background:"#c7ddf3ff", borderRadius:'50%', width:'30px', height:'30px', display:'flex', justifyContent:'center', alignItems:'center'}}><WifiCalling3OutlinedIcon sx={{color:"#1976d2",}}/></div>

                   <span style={{fontSize:'16px',marginLeft:'10px',fontWeight:'800'}}>CALL HISTORY</span>
                   </p> 
                </div>
                <div style={{display:'flex',alignItems:'center'}}>
                       
                    <AddCall/>
                </div>
                    </div>
                    <div style={{  width: '100%'}}></div>
                <table striped  style={{ width: '100%'}}>
                <thead>
                    <tr style={{backgroundColor:'#F9FAFB',height:'50px', border: '1px solid #e2e8f0', }}>
                    <th style={{textAlign:'left',fontSize:'14px',paddingLeft:'20px', fontWeight:'bold',  color:'#314158',  }}>Date and Time</th>
                    <th style={{textAlign:'left' ,fontSize:'14px', fontWeight:'bold',  color:'#314158', }}>Contact Name </th>
                    <th style={{textAlign:'left' ,fontSize:'14px', fontWeight:'bold',  color:'#314158', }}>Contact Number</th>
                    <th style={{textAlign:'left',fontSize:'14px', fontWeight:'bold' ,  color:'#314158', }}>Status</th>
                    <th style={{textAlign:'left' ,fontSize:'14px', fontWeight:'bold',  color:'#314158', }}>Call Remarks</th>
                    <th style={{textAlign:'center',fontSize:'14px', fontWeight:'bold',  color:'#314158', }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {[...(tableData || [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((row,index) =>
                    (
                        
                        <>
                        
                    <tr key={row.id} style={{height:'50px'}}>
                        <td style={{ fontSize:'14px',paddingLeft:'20px', fontWeight:'600', color:"#000" }}>{row?.createdAt ? (() => { const d = new Date(row.createdAt); const day = d.getDate().toString().padStart(2,'0'); const mon = d.toLocaleString('en-US',{month:'short'}); const yr = d.getFullYear(); const hr = d.getHours(); const min = d.getMinutes().toString().padStart(2,'0'); const ampm = hr >= 12 ? 'PM' : 'AM'; const hr12 = (hr % 12 || 12).toString().padStart(2,'0'); return `${day} ${mon} ${yr}, ${hr12}:${min} ${ampm}`; })() : '-'}</td>
                        <td style={{ fontSize:'14px',color:'#667085',     }}>{row?.name}</td>
                        <td style={{ fontSize:'14px', color:'#667085'  }}>{row.contact}</td>
                        <td style={{ fontSize:'14px',  color:'#667085' }}>{row.status}</td>
                        <td style={{ fontSize:'14px', color:'#667085'  }}>{row.remarks}</td>
                        <td style={{textAlign:'center'}}><AddReminder getReminderState={reminders} item={row}/></td>
                    </tr>
                    {index !== tableData.length - 1 && (
                            <tr>
                            <td colSpan="16">
                                <hr style={{ margin: 0, borderTop: '1px solid #ccc' }} />
                            </td>
                            </tr>
                        )}          </>
                    ))}
                </tbody>
                </table>
                </div>


        </div>

                        </div>
    )
}
export default LoanProfile
